PJQ.collections.submittals = {};

PJQ.models.submittals = {};

PJQ.views.submittals = {};

PJQ.modules.submittals = {
    routes: [
        {
            route: 'projects/:projectId/submittalsnew',
            name: 'submittalsnew',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "submittalsnew");
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.submittals.routes);

PJQ.views.submittals.Settings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'Settings'),
        subTemplates: {},
        maxWidth: 500,
        overrideLockDate: false,
        onChange: null
    },
    events: {
        'click .settings-save': 'onSave',
        'change .select-column': 'columnSelected',
        'change .input-override-lock-date': 'overrideLockChanged',
        'click .btn-add-workflow-template': 'addWorkflowTemplate',
        'click .btn-edit-workflow-template': 'editWorkflowTemplateClicked',
        'click .btn-delete-workflow-template': 'deleteWorkflowTemplateClicked',
        'click .extended-settings-checkbox': 'handeExtendedSettingsCheckbox'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;

        if (this.options.project != null) {
            this.model = await this.options.project.fetchSubmittalSettings();
            this.workflowTemplates = await this.options.project.fetchSubmittalWorkflowTemplates();
        } else {
            this.model = await PJQ.app.session.fetchSubmittalSettings();
        }

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            model: this.model,
            project: this.options.project,
            isFetched: this.isFetched,
            userSettings: this.options.userSettings
        };
    },
    onChange: function () {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(this.model);
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        if (this.model) {
            new PJQ.Binder(this.$el, this.model, {
                watchElements: [
                    'input',
                    'textarea'
                ],
                afterChange: _.bind(function (changeEl, attribute, value) {
                    if (attribute === 'isOverrideApprove') {
                        if (!value) {
                            this.model.set('approveNameOverride', null);
                        }
                        this.render();
                    } else if (attribute === 'enableWorkflow') {
                        this.model.set('enableWorkflow', value);
                        this.render();
                    }
                    this.onChange();
                }, this)
            });

            this.renderWorkflowTemplates();

            new PJQ.inputs.Selectpicker({
                el: this.$('.select-approval-mode'),
                defaultValue: this.model.get('approvalMode'),
                onChange: _.bind(function (value) {
                    this.model.set('approvalMode', value);
                    this.onChange();
                }, this)
            });

            new PJQ.views.contacts.ContactsSelectInput({
                el: this.$('.select-default-manager'),
                selectedContact: this.model.defaultManager,
                canViewContacts: this.options.project == null || this.options.project.hasPermission('projectContacts.canView'),
                canEdit: true,
                displayContactsBlock: true,
                canSwitchContext: this.options.project == null,
                context: this.options.project != null ? PJQ.constants.contacts.contexts.PROJECTCONTACTS : PJQ.constants.contacts.contexts.USERS,
                isSingleChoice: true,
                onChange: _.bind(function (selectedContact) {
                    this.model.defaultManager = selectedContact;
                    this.model.isDirty = true;
                }, this)
            });

            new PJQ.views.contacts.ContactsSelectInput({
                el: this.$('.select-default-distribution-list'),
                selectedContact: this.model.defaultDistributionList.models,
                canViewContacts: this.options.project == null || this.options.project.hasPermission('projectContacts.canView'),
                canEdit: true,
                displayContactsBlock: true,
                canSwitchContext: this.options.project == null,
                context: this.options.project != null ? PJQ.constants.contacts.contexts.PROJECTCONTACTS : PJQ.constants.contacts.contexts.USERS,
                isSingleChoice: false,
                onChange: _.bind(function (selectedContacts) {
                    this.model.defaultDistributionList.reset(selectedContacts);
                    this.model.isDirty = true;
                }, this)
            });

            if (this.options.userSettings) {
                this.rowsPerPageSelectPicker = new PJQ.inputs.Selectpicker({
                    el: this.$('.rows-per-page'),
                    defaultValue: this.options.userSettings.getSettings(PJQ.constants.submittals.view.SUBMITTALS).rowsPerPage,
                    onChange: _.bind(function (value) {
                        this.onChange();
                    }, this)
                });

                this.dataTable = new PJQ.views.dataTables.DataTable({
                    el: this.$('div.column-settings'),
                    data: this.options.submittalsView.getColumns(true),
                    isHideSearch: true,
                    order: [],
                    columns: [
                        {"data": "title", "title": "Column", "orderable": false},
                        {
                            "data": "visible",
                            "title": "Show",
                            "orderable": false,
                            "searchable": false,
                            "render": _.bind(function (data) {
                                return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (data ? ' checked ' : '') + 'class="select-column"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                            }, this),
                            "width": '10%'
                        }
                    ],
                    dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
                });
            }
        }
    },
    handeExtendedSettingsCheckbox: function (e) {
        let extendedSettings = this.model.get('extendedSettings'),
            extendedSettingsInputMap = {
                defaultIsPublic: '.default-is-public'
            };

        Object.keys(extendedSettingsInputMap).forEach(key => {
            extendedSettings[key] = this.$(extendedSettingsInputMap[key]).prop('checked');
        });

        this.model.set('extendedSettings', extendedSettings);

        this.onChange();
    },
    addWorkflowTemplate: function (e) {
        let newTemplate = new PJQ.models.submittals.WorkflowTemplate({
            projectId: this.options.project.id
        });
        this.editWorkflowTemplate(newTemplate);
    },
    editWorkflowTemplateClicked: function (e) {
        let $target = $(e.currentTarget),
            $tr = $target.closest('tr'),
            row = this.workflowTemplatesDataTable.getRow($tr),
            template = row.data();
        this.editWorkflowTemplate(template);
    },
    editWorkflowTemplate: function (template) {
        let isNew = template.isNew();
        new PJQ.views.submittals.EditWorkflowTemplateModal({
            model: template,
            project: this.options.project,
            onSave: () => {
                if (isNew) {
                    this.workflowTemplatesDataTable.addRow(template);
                    this.workflowTemplates.add(template);
                }
                this.workflowTemplatesDataTable.refresh();
            },
            onDelete: () => {
                if (template.id > 0) {
                    let row = this.workflowTemplatesDataTable.getRow(template.cid);
                    if (row != null) {
                        this.workflowTemplatesDataTable.removeRow(row);
                    }
                }

                this.workflowTemplatesDataTable.refresh();
            }
        });
    },
    deleteWorkflowTemplateClicked: function (e) {
        let $target = $(e.currentTarget),
            $tr = $target.closest('tr'),
            row = this.workflowTemplatesDataTable.getRow($tr),
            template = row.data();
        this.deleteWorkflowTemplate(template);
    },
    deleteWorkflowTemplate: function (template) {
        if (template == null) {
            return;
        }

        new PJQ.views.modals.DeleteCancel({
            header: "Delete Submittal Workflow Template?",
            body: "Are you sure you want to delete this workflow template? This cannot be undone.",
            onDelete: () => {
                template.destroy({
                    success: () => {
                        if (template.id > 0) {
                            let row = this.workflowTemplatesDataTable.getRow(template.cid);
                            if (row != null) {
                                this.workflowTemplatesDataTable.removeRow(row);
                            }
                        }

                        this.workflowTemplatesDataTable.refresh();
                    },
                    error: () => {
                        PJQ.notifications.notify.errorNotify({
                            message: 'Failed to delete workflow template'
                        });
                    }
                });
            }
        });
    },
    renderWorkflowTemplates: function () {
        if (this.workflowTemplates == null) {
            return;
        }

        this.workflowTemplatesDataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.workflow-templates'),
            data: this.workflowTemplates.models,
            isHideSearch: true,
            language: {
                emptyTable: 'No Templates have been created yet',
                zeroRecords: 'No Templates have been created yet'
            },
            isStriped: false,
            paging: false,
            order: [[0, "asc"]],
            columns: [
                {
                    "data": "attributes.name",
                    "columnData": "attributes.name",
                    "title": "Name",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data, type, row) {
                        return '<a class="btn-edit-workflow-template" href="javascript:void(0)" data-id="' + row.id + '">' + row.get('name') + '</a>';
                    }, this)
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "70px",
                    "render": _.bind(function (data, type, row) {
                        let html = '<div class="text-align-right show-on-row-hover">'
                        html += '<button type="button" class="btn btn-info btn-edit-workflow-template"><i class="fal fa-pencil"></i></button><button type="button" class="btn btn-danger btn-delete-workflow-template ml-1"><i class="fal fa-trash"></i></button>'
                        return html + '</div>';
                    }, this)
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: (row) => {
                            this.deleteWorkflowTemplate(row.data());
                        },
                        isShown: () => {
                            return this.options.isEdit;
                        },
                    }
                ]
            },
            onRowDoubleClick: (row) => {
                this.editWorkflowTemplate(row.data());
            }
        });
    },
    columnSelected: function (sender) {
        this.dataTable.dataTable.row($(sender.currentTarget).closest('tr')).data().visible = $(sender.currentTarget).prop('checked');
    }
});

PJQ.views.submittals.SettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'Modal-Submittal-Settings'),
        minWidth: "600px",
    },
    events: {
        'click .settings-save': 'onSave'
    },
    afterRender: function () {
        this.settingsView = new PJQ.views.submittals.Settings({
            el: this.$('.modal-body'),
            submittalsView: this.options.submittalsView,
            model: this.model,
            userSettings: this.options.userSettings,
            project: this.options.project
        });
    },
    onSave: function () {
        let loader = new PJQ.Loader(this.$('.modal-content'));
        this.options.submittalsView.options.userSettings.getSettings(PJQ.constants.submittals.view.SUBMITTALS).rowsPerPage = parseInt(this.settingsView.rowsPerPageSelectPicker.getValue());

        let columns = this.options.submittalsView.options.userSettings.getSettings(PJQ.constants.submittals.view.SUBMITTALS).columns;
        _.each(this.settingsView.dataTable.dataTable.data(), function (row) {
            if (row.visible) {
                if (columns.indexOf(row.columnData) === -1)
                    columns.push(row.columnData);
            } else {
                columns = _.filter(columns, function (column) {
                    return (column != row.columnData);
                });
            }
        });
        this.options.submittalsView.options.userSettings.getSettings(PJQ.constants.submittals.view.SUBMITTALS).columns = columns;
        this.options.submittalsView.options.userSettings.save(null, {
            success: _.bind(function () {
                this.settingsView.model.save(null, {
                    success: _.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Submittal settings saved'
                        });
                        if (typeof this.options.onSave === 'function') {
                            this.options.onSave();
                        }
                        this.removeModal();
                    }, this),
                    error: function () {
                        loader.remove();
                    }
                });
            }, this)
        });
    }
});

PJQ.views.submittals.TemplateManagement = PJQ.views.templates.TemplateManagement.extend({
    beforeFirstRender: function () {
        this.collection = new PJQ.collections.submittals.Templates();
        this.listenTo(this.collection, 'fetch', this.render);
        this.collection.fetch();
    },
    addTemplate: function () {
        new PJQ.views.templates.NewTemplateModal({
            model: new PJQ.models.submittals.Template(),
            onSave: _.bind(function (template) {
                this.collection.add(template);
                this.editTemplate(template);
            }, this)
        });
    },
    editTemplate: function (template) {
        new PJQ.views.submittals.EditTemplateModal({
            model: template,
            onClose: _.bind(function () {
                this.dataTable.refresh();
            }, this),
            onDelete: _.bind(function (template) {
                if (template.id > 0) {
                    let row = this.dataTable.getRow(template.cid);
                    this.collection.remove(template);
                    template.destroy();
                    this.dataTable.removeRow(row);
                }
            }, this)
        });
    }
});

PJQ.views.submittals.ItemTypeSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'item-type-settings')
    },
    events: {
        'click .add-item-type': 'addItemType',
        'click .edit-item-type': 'editItemTypeClicked',
        'click .delete-item-type': 'deleteItemTypeClicked'
    },
    beforeFirstRender: function () {
        if (this.collection == null) {
            this.fetchItemTypes(_.bind(function () {
                this.render();
            }, this));
        }
    },
    fetchItemTypes: function (callback) {
        this.collection = new PJQ.collections.submittals.ItemTypes();

        this.collection.fetch({
            success: _.bind(function () {
                callback();
            }, this)
        })
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".item-types"),
            data: this.collection.models,
            rowId: "cid",
            order: [0, 'asc'],
            language: {
                zeroRecords: 'Click "Add" to create a new line item'
            },
            sortableOptions: {
                data: this.collection
            },
            isHideSearch: true,
            pageLength: 50,
            bSort: false,
            onRowDoubleClick: _.bind(function (row) {
                this.editItemType(row.data());
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: _.bind(function (row) {
                            this.editItemType(row.data());
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: _.bind(function (row) {
                            this.deleteItemType(row);
                        }, this)

                    }
                ]
            },
            columns: [
                {
                    "data": "attributes.sortOrder",
                    "title": "",
                    "searchable": false,
                    "orderable": false,
                    "visible": false
                },
                {
                    "title": "Name",
                    "data": "attributes.name",
                    "orderable": true
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "80px",
                    "render": _.bind(function (data, type, row) {
                        return '<div class="text-align-right show-on-row-hover"><button type="button" class="btn btn-info edit-item-type ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button><button type="button" class="btn btn-danger delete-item-type ht-30p wd-35p ml-1 fs-14"><span class="fal fa-trash"></span></button></div>';
                    }, this)
                }
            ]
        });
    },
    addItemType: function () {
        new PJQ.views.submittals.EditItemTypeModal({
            onSave: _.bind(function (model) {
                this.collection.add(model);
                this.dataTable.addRow(model);
            }, this)
        })
    },
    editItemTypeClicked: function (e) {
        let $target = $(e.currentTarget),
            $row = $target.closest('tr'),
            row = this.dataTable.getRow($row),
            itemType = row.data();

        this.editItemType(itemType);
    },
    deleteItemTypeClicked: function (e) {
        let $target = $(e.currentTarget),
            $row = $target.closest('tr'),
            row = this.dataTable.getRow($row),
            itemType = row.data();

        this.deleteItemType(itemType);
    },
    deleteItemType: function (row) {
        let itemType = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this item type?",
            onDelete: _.bind(function () {
                this.collection.remove(itemType);
                itemType.destroy();
                this.dataTable.removeRow(row);
            }, this)
        });
    },
    editItemType: function (itemType) {
        new PJQ.views.submittals.EditItemTypeModal({
            model: itemType,
            onSave: _.bind(function () {
                this.dataTable.refresh();
            }, this)
        })
    }
});

PJQ.views.submittals.EditItemTypeModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'modal-edit-item-type'),
        maxWidth: "400px",
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-cancel': 'cancel'
    },
    beforeModalCreated: function () {
        if (!this.options.model) {
            this.model = new PJQ.models.submittals.ItemType({
                name: "",
                sortOrder: 1
            });
        } else {
            this.model = this.options.model;
        }
        this.render();
    },
    renderData: function () {
        return {
            model: this.model
        }
    },
    afterRender: function () {
        if (this.model) {
            new PJQ.Binder(this.$el, this.model, {
                watchElements: [
                    'input'
                ]
            });
        }
    },
    cancel: function () {
        this.model.restore();
        this.removeModal();
    },
    save: function () {
        this.model.save(null, {
            success: _.bind(function (model) {
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(model);
                    this.removeModal();
                }
            }, this)
        })
    }
});

PJQ.views.submittals.SubmittalStatusSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'status-settings')
    },
    events: {
        'click .add-status': 'addStatus',
        'click .edit-status': 'editStatusClicked',
        'click .delete-status': 'deleteStatusClicked'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;

        this.collection = await PJQ.app.session.fetchSubmittalStatuses();

        this.isFetched = true;
        this.render();
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".statuses-table"),
            data: this.collection.models,
            rowId: "cid",
            order: [0, 'asc'],
            language: {
                zeroRecords: 'Click "Add" to create a new Status'
            },
            sortableOptions: {
                data: this.collection,
                stop: (a, b) => {
                    let self = this,
                        sortedRow = b.item[0].id,
                        pageInfo = self.dataTable.dataTable.page.info();
                    self.$('tbody>tr').each(function (index, html) {
                        let row = $(html)[0].id,
                            rowData = self.collection.get(row),
                            sortNumber = (pageInfo.page * pageInfo.length) + (index + 1);
                        rowData.set('sortOrder', sortNumber);
                        if (row === sortedRow) {
                            self.dataTable.onRowSorted(rowData, sortNumber)
                        }
                    });
                }
            },
            isHideSearch: true,
            pageLength: 50,
            bSort: false,
            onRowDoubleClick: _.bind(function (row) {
                this.editStatus(row.data());
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: _.bind(function (row) {
                            this.editStatus(row.data());
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        isShown: (row) => {
                            return !row.data().get('isDefault');
                        },
                        onClick: (row) => {
                            this.deleteStatus(row);
                        }

                    }
                ]
            },
            columns: [
                {
                    "data": "attributes.sortOrder",
                    "title": "",
                    "searchable": false,
                    "orderable": false,
                    "visible": false
                },
                {
                    "title": "Name",
                    "data": "attributes.name",
                    "orderable": true
                },
                {
                    "title": "Type",
                    "data": "attributes.type",
                    "orderable": true,
                    "render": (data, type, row) => {
                        let statusType = row.get('type');
                        return '<span style="color:' + PJQ.constants.submittals.statusTypeColors[statusType] + '">' + PJQ.constants.submittals.statusTypeNames[data] + '</span>';
                    }
                },
                {
                    "title": "Default",
                    "data": "attributes.isDefault",
                    "orderable": true,
                    "render": (data, type, row) => {
                        return data ? "Yes" : "No";
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    resizable: false,
                    "width": "100px",
                    "render": (data, type, row) => {
                        let html = '<div class="text-align-right show-on-row-hover" style="width:80px;"><button type="button" class="btn btn-info edit-status"><span class="fal fa-pencil"></span></button>';

                        if (!row.get('isDefault')) {
                            html += '<button type="button" class="btn btn-danger delete-status ml-1"><span class="fal fa-trash"></span></button>'
                        }

                        return html + '</div>';
                    }
                }
            ]
        });
    },
    copyStatuses: function (callback, status) {
        this.collection.copy((newStatuses) => {
            this.collection.reset(newStatuses);
            this.render();
            if (typeof callback === 'function') {
                status = status ? _.find(this.collection.models, function (model) {
                    return model.get('name') === status.get('name') && model.get('type') === status.get('type');
                }) : null;

                callback(status);
            }
        });
    },
    addStatus: function () {
        this.editStatus();
    },
    editStatusClicked: function (e) {
        let $target = $(e.currentTarget),
            $row = $target.closest('tr'),
            row = this.dataTable.getRow($row),
            status = row.data();

        this.editStatus(status);
    },
    editStatus: function (status) {
        let isNew = status == null,
            fnAdd = (copiedStatus) => {
                if (copiedStatus) {
                    status = copiedStatus;
                }

                new PJQ.views.submittals.EditStatusModal({
                    model: status,
                    statuses: this.collection,
                    onSave: _.bind(function (updatedStatus) {
                        if (isNew) {
                            this.collection.add(updatedStatus);
                            this.dataTable.addRow(updatedStatus);
                        }

                        if (updatedStatus.get('isDefault')) {
                            _.each(this.collection.models, function (collectionStatus) {
                                if (collectionStatus !== updatedStatus && collectionStatus.get('type') === updatedStatus.get('type')) {
                                    collectionStatus.set('isDefault', false);
                                }
                            });
                        }

                        this.dataTable.refresh();
                    }, this)
                })
            };

        if (this.collection.models[0].get('masterUserId') === -1) {
            this.copyStatuses(fnAdd, status);
        } else {
            fnAdd();
        }
    },
    deleteStatusClicked: function (e) {
        let $target = $(e.currentTarget),
            $row = $target.closest('tr'),
            row = this.dataTable.getRow($row)

        this.deleteStatus(row);
    },
    deleteStatus: function (row) {
        let status = row.data(),
            canDelete = _.size(_.filter(this.collection.models, function (model) {
                if (model.get('type') === status.get('type') && model !== status) {
                    return model;
                }
            })) > 0;

        if (canDelete) {
            let fnDelete = (copiedStatus) => {
                if (copiedStatus) {
                    status = copiedStatus;
                }

                new PJQ.views.modals.DeleteCancel({
                    header: "Confirm Deletion",
                    body: "Are you sure you want to delete this status?",
                    onDelete: _.bind(function () {
                        this.collection.remove(status);
                        status.destroy();
                        this.dataTable.removeRow(row);
                    }, this)
                });
            }
            // Currently we only have 1 of each status type by default so this won't happen, but if we ever have more than 1 of each type, we need to copy the statuses first.
            if (this.collection.models[0].get('masterUserId') === -1) {
                this.copyStatuses(fnDelete, status);
            } else {
                fnDelete();
            }
        } else {
            new PJQ.Alert(this.$('.error'), {
                type: 'danger',
                text: '"' + status.get('name') + '" is the only ' + PJQ.constants.submittals.statusTypeNames[status.get('type')] + ' type status and cannot be deleted until another is created.',
                animation: {
                    in: 'fadeIn',
                    out: 'fadeOut'
                },
                timeout: 8000
            });
        }
    }
});

PJQ.views.submittals.EditStatusModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'modal-edit-status'),
        maxWidth: "400px",
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-cancel': 'cancel'
    },
    beforeModalCreated: function () {
        if (!this.model) {
            this.model = new PJQ.models.submittals.Status({
                name: "",
                isDefault: false,
                shouldLock: false,
                asNoted: false,
                sortOrder: _.size(this.options.statuses) + 1,
                type: PJQ.constants.submittals.statusTypes.NEW
            });
        }

        // If the model comes in as default, it's the only default status.
        this.mustBeDefault = this.model.get('isDefault');

        this.render();
    },
    renderData: function () {
        return {
            model: this.model,
            mustBeDefault: this.mustBeDefault
        }
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input'
            ]
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-status-type'),
            defaultValue: this.model.get('type'),
            isDisabled: !this.model.isNew(),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.model.set('type', value);
                this.render();
            }, this)
        });
    },
    cancel: function () {
        this.model.restore();
        this.removeModal();
    },
    validate: function () {
        let isValid = true;

        PJQ.helpers.inputHelpers.setInputError(this.$('.input-status-name'), true);
        if (_.size(this.model.get('name').trim()) === 0) {
            isValid = false;
            PJQ.helpers.inputHelpers.setInputError(this.$('.input-status-name'), false);
        }

        return isValid;
    },
    save: function () {
        if (this.validate()) {
            this.model.save(null, {
                success: _.bind(function (model) {
                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(model);
                        this.removeModal();
                    }
                }, this)
            })
        }
    }
});

PJQ.views.submittals.EditSubmittalModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'Modal-Edit-Submittal'),
        subTemplates: {
            contactBadge: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Contacts-Select-Input-Contacts'),
            comments: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'Comments'),
        },
        width: '90%',
        maxWidth: 1500,
        isShowCloseButton: true,
        onSave: _.noop,
        isAdmin: true
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-close': 'close',
        'click .submittal-delete': 'delete',
        'click .btn-add-comment': 'addCommentClicked',
        'click .btn-mark-submitted': 'submit',
        'click .btn-submit': 'submit',
        'click .btn-approve': 'approve',
        'click .btn-reject': 'reject',
        'click .btn-notification-history': 'viewNotificationHistory',
        'click .btn-edit-history': 'viewEditHistory',
        'click .btn-upload-files': 'uploadFile',
        'click .edit-file': 'editFileClicked',
        'click .edit-note': 'editNoteClicked',
        'click .btn-dl-approver-attachment': 'downloadAttachment',
        'click .btn-download-all-attachments': 'downloadAllAttachments',
        'click .expand-history': 'renderHistory',
        'click .download-history-file': 'downloadHistoryClicked',
        'click .btn-export': 'exportSubmittal',
        'click .btn-delete-comment': 'deleteComment',
        'click .btn-void': 'voidSubmittal',
        'click .btn-edit-workflow': 'editWorkflow',
        'click .btn-save-workflow': 'saveWorkflow',
        'click .btn-view-revision': 'viewRevision',
        'click .btn-create-revision': 'createRevision',
        'click .btn-submittal-respond': 'respondToSubmittal',
        'click .btn-close-submittal': 'closeSubmittal',
        'click .btn-email-submittal': 'emailSubmittal',
        'click .btn-distribute-submittal': 'distributeSubmittal',
        'click .btn-reopen-submittal': 'reopenSubmittal'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.options.project != null) {
            this.options.isAdmin = this.options.project.hasPermission('submittals.isAdmin');
        } else {
            this.options.isAdmin = true;
        }
        this.options.canEditPeople = this.options.isAdmin;
        this.options.canEdit = true;
        this.options.canUpload = true;
        this.options.canSubmit = this.options.project != null;

        if (this.model == null) {
            let submitter;
            if (!this.options.isAdmin) {
                submitter = PJQ.app.session.contact != null ? PJQ.app.session.contact : PJQ.app.session.user;
            }

            this.model = new PJQ.models.submittals.Submittals({
                projectId: this.options.project ? this.options.project.id : null,
                templateId: this.options.templateId,
                submitter: submitter ? submitter.toJSON() : null
            });
        }

        if (this.options.project != null) {
            this.options.settings = await this.options.project.fetchSubmittalSettings();
            this.options.itemTypes = await this.options.project.fetchSubmittalItemTypes();
            this.options.customFields = await this.options.project.fetchSubmittalCustomFields();
            this.options.statuses = await this.options.project.fetchSubmittalStatuses();
        } else {
            this.options.settings = await PJQ.app.session.fetchSubmittalSettings();
            this.options.itemTypes = await PJQ.app.session.fetchSubmittalItemTypes();
            this.options.customFields = await PJQ.app.session.fetchSubmittalCustomFields();
            this.options.statuses = await PJQ.app.session.fetchSubmittalStatuses();
        }
        this.changedAnnotations = new PJQ.collections.drawings.Annotations();

        if (this.model.isNew()) {
            let defaultNewStatus = this.options.statuses.findWhere({
                    isDefault: true,
                    type: PJQ.constants.submittals.statusTypes.NEW
                }),
                defaultManager = this.options.settings?.get('defaultManager'),
                defaultDistributionList = this.options.settings?.get('defaultDistributionList');

            this.model.set('statusId', defaultNewStatus.id);

            if (defaultManager && this.options.settings?.get('enableWorkflow')) {
                this.model.manager = new PJQ.models.projectContacts.ProjectContact(defaultManager);
                this.model.set('managerId', defaultManager);
            }

            if (defaultDistributionList) {
                this.model.distributionList = new PJQ.collections.projectContacts.ProjectContacts(defaultDistributionList);
                this.model.set('distributionList', defaultDistributionList);
            }

            if(this.options.settings?.get('extendedSettings').defaultIsPublic){
                this.model.set('isPublic', true);
            }
        } else {
            await this.model.fetch();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        let searchId = PJQ.app.session.contact ? PJQ.app.session.contact.get('id') : PJQ.app.session.user.get('id'),
            isSubmitter = this.model.get('isSubmitter') || (this.model.submitter && this.model.submitter.id === searchId),
            isCreator = this.model.get('isCreator') || (this.model.createdBy && this.model.createdBy.id === searchId);

        this.options.canEditPeople = this.options.isAdmin;
        this.options.isApprover = this.model.get('isApprover') || null != _.findWhere(this.model.get('approvers'), {id: searchId});
        if (this.model.isNew()) {
            this.options.canEdit = true;
            this.options.canUpload = true;
            this.options.canSubmit = this.options.project != null;
        } else if (this.model.get('hasRevision') || this.model.get('isClosed') || this.model.isVoidStatus(this.options.statuses)) {
            this.options.canEditPeople = false;
            this.options.canEdit = false;
            this.options.canUpload = false;
            this.options.canSubmit = false;
        } else if (this.model.get('isClosed') || this.model.isApprovedStatus(this.options.statuses) || this.model.isVoidStatus(this.options.statuses)) {
            this.options.canEdit = false;
            this.options.canUpload = false;
            this.options.canSubmit = false;
        } else if (this.model.isPartiallyApproved()) {
            this.options.canEdit = this.options.isAdmin;
            this.options.canUpload = this.options.isAdmin || this.options.isApprover;
            this.options.canSubmit = false;
        } else if (this.model.isSubmittedStatus(this.options.statuses)) {
            this.options.canEdit = this.options.isAdmin;
            this.options.canUpload = this.options.isAdmin || (!this.options.settings.get('enableWorkflow') && this.options.isApprover);
            this.options.canSubmit = false;
        } else {
            this.options.canEditPeople = this.options.isAdmin;
            this.options.canEdit = this.options.isAdmin;
            this.options.canSubmit = this.options.project != null && (this.options.isAdmin || this.options.isApprover || isSubmitter || isCreator);
            this.options.canUpload = this.options.canSubmit || isCreator
        }

        if (this.model.statusShouldLock(this.options.statuses)) {
            this.options.canEdit = false;
            this.options.canEditPeople = false;
            this.options.canSubmit = false;
            this.options.canUpload = false;
            this.options.isApprover = false;
        }

        this.options.hideItemTypes = PJQ.app.session.project ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.HIDE_SUBMITTAL_ITEM_TYPE) : PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.HIDE_SUBMITTAL_ITEM_TYPE);
    },
    renderData: function () {
        return {
            model: this.model,
            project: this.options.project,
            customFields: this.options.customFields,
            settings: this.options.settings,
            statuses: this.options.statuses,
            itemTypes: this.options.itemTypes ? this.options.itemTypes : null,
            canEdit: this.options.canEdit,
            canEditPeople: this.options.canEditPeople,
            canSubmit: this.options.canSubmit,
            isAdmin: this.options.isAdmin,
            isApprover: this.options.isApprover,
            canUpload: this.options.canUpload,
            hideItemTypes: this.options.hideItemTypes,
            isFetched: this.isFetched
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        if (this.options.itemTypes == null || !this.options.itemTypes.isFetched
            || this.options.customFields == null || !this.options.customFields.isFetched) {
            return;
        }
        if (this.options.project) {
            PJQ.app.session.project.fetchSubmittalCustomFields(_.bind(function (customFields) {
                this.customFields = customFields;
                this.renderCustomFields();
            }, this));
        }

        if (this.options.canEdit) {
            new PJQ.Binder(this.$el, this.model, {
                watchElements: [
                    'input',
                    'textarea'
                ]
            });
        }

        this.dueDatePicker = new PJQ.inputs.Datepicker({
            el: this.$('.input-due-date'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('dueDate') ? new Date(this.model.get('dueDate')) : null
            },
            onChange: _.bind(function (newDate) {
                this.model.set('dueDate', newDate);
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.input-received-date'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('receivedDate') ? new Date(this.model.get('receivedDate')) : null
            },
            onChange: _.bind(function (newDate) {
                this.model.set('receivedDate', newDate);
            }, this)
        });

        new PJQ.views.groups.GroupsSelectInput({
            el: this.$('.submittal-groups'),
            isShowAddButton: false,
            addButton: this.$('.btn-edit-groups'),
            groupLevels: PJQ.app.session.project ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS) : PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS),
            groupUserId: PJQ.app.session.project ? PJQ.app.session.project.get('masterUserId') : PJQ.app.session.get('masterUserId'),
            selectedGroups: this.model.groups.models,
            isReadOnly: !this.options.canEdit,
            onAfterSave: _.bind(function (selectedGroups) {
                this.model.groups.reset(selectedGroups);
                this.model.isDirty = true;
            }, this)
        });

        if (this.model.ballInCourt || (this.options.settings.get('enableWorkflow') && this.model.isSubmittedStatus(this.options.statuses) && this.model.workflow.getCurrentStep() != null && _.size(this.model.workflow.getCurrentStep()?.get('approvers')) > 0)) {
            new PJQ.views.contacts.ContactsSelectInput({
                el: this.$('.submittal-ball-in-court'),
                selectedContact: this.model.ballInCourt ?? _.map(this.model.workflow.getCurrentStep().approvers.models, (approver) => {
                    return new PJQ.models.projectContacts.ProjectContact(approver.get('person'))
                }),
                canViewContacts: this.options.project == null || this.options.project.hasPermission('projectContacts.canView'),
                isSingleChoice: this.model.ballInCourt != null,
                isReadOnly: true,
                displayContactsBlock: true
            });
        }

        new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.submittal-submitter'),
            selectedContact: this.model.submitter,
            canViewContacts: this.options.project == null || this.options.project.hasPermission('projectContacts.canView'),
            canEdit: this.options.canEditPeople,
            displayContactsBlock: true,
            canSwitchContext: this.options.project == null,
            context: this.options.project != null ? PJQ.constants.contacts.contexts.PROJECTCONTACTS : PJQ.constants.contacts.contexts.USERS,
            isSingleChoice: true,
            onChange: (selectedContact) => {
                this.model.submitter = selectedContact;
                this.model.isDirty = true;
            }
        });
        let approvers = [];
        _.each(this.model.get('approvers'), function (approver) {
            approvers.push(new PJQ.models.projectContacts.ProjectContact(approver));
        })

        if (this.options.settings.get('enableWorkflow') && (!this.model.isNew() || this.options.isAdmin)) {
            if (this.options.project != null) {
                this.workflowView = new PJQ.views.submittals.WorkflowView({
                    el: this.$('.workflow-outer'),
                    model: this.model.workflow,
                    submittal: this.model,
                    project: this.options.project,
                    isEdit: this.model.isNew() && this.options.isAdmin,
                    canChangeBallInCourt: this.options.canEdit && this.options.isAdmin && !this.model.get('isClosed') && this.model.isSubmittedStatus(this.options.statuses),
                    canEdit: this.options.canEdit && this.options.isAdmin && !this.model.get('isClosed') && !this.model.isApprovedStatus(this.options.statuses) && !this.model.isVoidStatus(this.options.statuses),
                    canRespond: !this.model.get('isClosed'),
                    onChange: () => {
                        this.model.isDirty = true;
                    },
                    onRespond: () => {
                        this.render();
                    },
                    onSetBallInCourt: () => {
                        this.render();
                    }
                });
            }

            this.managerPicker = new PJQ.views.contacts.ContactsSelectInput({
                el: this.$('.submittal-manager'),
                selectedContact: this.model.manager,
                canViewContacts: this.options.project == null || this.options.project.hasPermission('projectContacts.canView'),
                canEdit: this.options.canEditPeople,
                displayContactsBlock: true,
                canSwitchContext: this.options.project == null,
                context: this.options.project != null ? PJQ.constants.contacts.contexts.PROJECTCONTACTS : PJQ.constants.contacts.contexts.USERS,
                isSingleChoice: true,
                onChange: _.bind(function (selectedContact) {
                    this.model.manager = selectedContact;
                    this.model.isDirty = true;
                }, this)
            });
        } else {
            new PJQ.views.contacts.ContactsSelectInput({
                el: this.$('.submittal-approval-list'),
                subTemplates: {
                    contactBadge: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'Approver-Input-Contacts')
                },
                isSortable: true,
                allowDuplicate: this.options.settings.get('approvalMode') === PJQ.constants.submittals.approvalModes.SEQUENTIAL,
                onStop: (array) => {
                    let approvers = this.model.get('approvers'),
                        newApprovers = [],
                        usedIdx = [];
                    _.each(array, function (id) {
                        let approverIdx = _.findIndex(approvers, function (approver, idx) {
                            return approver.id === id && usedIdx.indexOf(idx) === -1;
                        });
                        if (approverIdx === -1) {
                            return;
                        }
                        usedIdx.push(approverIdx);

                        newApprovers.push(approvers[approverIdx]);
                    });
                    this.model.set('approvers', newApprovers);
                    this.model.isDirty = true;
                },
                contactsRenderData: {
                    isAdmin: this.options.isAdmin,
                    showApproval: (contact, index) => {
                        return this.model.isSubmittedStatus(this.options.statuses);
                    },
                    canApprove: (contact, index) => {
                        return !contact.get('hasApproved') && this.model.isSubmittedStatus(this.options.statuses)
                            && this.model.isUserCurrentApprover(this.options.settings.get('approvalMode'), contact);
                    }
                },
                onApproveBehalf: (contact) => {
                    this.model.set('asNotedCommentId', null);

                    let isNew = this.model.isNew(),
                        fnApprove = (comment) => {
                            // todo: save comment
                            this.model.approve(null, contact.id, (success, err) => {
                                if (!success) {
                                    if (!this.handleStatusError(err)) {
                                        let errTxt = 'Encountered an error while approving the submittal';
                                        PJQ.notifications.notify.errorNotify({
                                            message: errTxt
                                        });
                                    }
                                    return;
                                }

                                if (this.options.onSave) {
                                    this.options.onSave(this.model, isNew);
                                }
                                this.render();
                            });
                        };

                    new PJQ.views.modals.YesNo({
                        header: "Add comment?",
                        body: 'Would you like to include a comment on behalf of this approver?',
                        onYes: () => {
                            this.checkActiveResponse(false, (hadComment) => {
                                if (!hadComment) {
                                    new PJQ.views.submittals.StatusChangeCommentModal({
                                        model: this.model,
                                        title: 'Submission Note',
                                        onSave: _.bind(function (model, comment) {
                                            fnApprove(comment);
                                        }, this)
                                    })
                                } else {
                                    fnApprove();
                                }
                            });
                        },
                        onNo: () => {
                            fnApprove();
                        }
                    });
                },
                selectedContact: approvers,
                canViewContacts: this.options.project == null || this.options.project.hasPermission('projectContacts.canView'),
                canEdit: this.options.canEditPeople,
                displayContactsBlock: true,
                context: this.options.project != null ? PJQ.constants.contacts.contexts.PROJECTCONTACTS : PJQ.constants.contacts.contexts.USERS,
                isSingleChoice: false,
                canSwitchContext: this.options.project == null,
                onChange: (selectedContacts) => {
                    let newApprovers = [],
                        approvedByIds = _.map(_.filter(this.model.get('approvers'), (approver) => {
                            return approver.hasApproved;
                        }), (approver) => {
                            return approver.id;
                        });
                    _.each(selectedContacts, function (contact) {
                        let existApproverIdx = approvedByIds.indexOf(contact.id)
                        contact.set({
                            isApprover: true,
                            hasApproved: existApproverIdx !== -1
                        });
                        newApprovers.push(contact);

                        if (existApproverIdx !== -1) {
                            delete approvedByIds[existApproverIdx];
                        }
                    }, this)
                    this.model.set('approvers', newApprovers);
                    this.model.isDirty = true;
                }
            });
        }

        if (this.options.isAdmin) {
            new PJQ.views.contacts.ContactsSelectInput({
                el: this.$('.submittal-distribution-list'),
                selectedContact: this.model.distributionList.models,
                canViewContacts: this.options.project == null || this.options.project.hasPermission('projectContacts.canView'),
                canEdit: this.options.canEditPeople,
                displayContactsBlock: true,
                canSwitchContext: this.options.project == null,
                context: this.options.project != null ? PJQ.constants.contacts.contexts.PROJECTCONTACTS : PJQ.constants.contacts.contexts.USERS,
                isSingleChoice: false,
                onChange: _.bind(function (selectedContacts) {
                    this.model.distributionList.reset(selectedContacts);
                    this.model.isDirty = true;
                }, this)
            });
        }

        if (!this.options.hideItemTypes) {
            new PJQ.inputs.Selectpicker({
                el: this.$('.select-item-type'),
                noneSelectedText: 'Select Value',
                isMultiple: true,
                isIntChoices: true,
                defaultValue: _.map(this.model.itemTypes.models, function (model) {
                    return model.id;
                }),
                onChange: _.bind(function (value) {
                    this.model.itemTypes.reset(this.options.itemTypes.get(value));
                    this.model.isDirty = true;
                }, this)
            });
        }

        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.submittal-file-uploader'),
            context: 'submittal',
            contextId: this.model.id,
            canAddAnnotations: this.options.canEdit,
            onAnnotationChange: this.model.id > 0 ? null : (annotation) => {
                this.changedAnnotations.merge(annotation);
            },
            mergeAnnotations: this.changedAnnotations,
            collection: this.model.attachments,
            canUpload: this.options.canUpload,
            canDelete: this.options.isAdmin,
            hasNotes: true,
            isVersioned: true,
            versionByName: true,
            previewImageDimension: 150,
            includeProjectAttachments: true,
            onNoteChanged: (attachment) => {
                if (!(attachment.id > 0)) {
                    return;
                }

                new PJQ.ajax.Request({
                    endpoint: this.options.project.endpoint() + '/submittals/attachments/' + attachment.id,
                    isAPIv2: true,
                    data: attachment.toJSON()
                }).patch().done(() => {
                    PJQ.notifications.notify.successNotify({
                        message: 'Attachment note updated'
                    });
                }).fail((xhr, err, result) => {
                    PJQ.notifications.notify.errorNotify({
                        message: 'Encountered an error while updating the attachment note'
                    });
                });
            },
            onNewVersion: () => {
                this.model.isDirty = true;
                this.fileUploader.render();
            },
            onSuccess: () => {
                this.model.isDirty = true;
            },
            onDelete: (attachment, callback) => {
                if (attachment.id > 0) {
                    attachment.set('isDeleted', true);
                } else {
                    this.model.attachments.remove(attachment);
                }
                this.model.isDirty = true;
                callback();
            }
        });

        this.renderCustomFields();
        this.renderComments();
    },
    renderComments: function () {
        this.renderSubTemplate(false, this.options.subTemplates.comments, this.$('.comments-outer'), {
            comments: this.model.comments.models,
            model: this.model,
            settings: this.options.settings,
            statuses: this.options.statuses,
            canDelete: this.options.canEdit && (this.options.project ? this.options.project.hasPermission('submittals.canDeleteComments') : true)
        });
    },
    respondToSubmittal: function (e) {
        let currentStep = this.model.workflow.getCurrentStep();
        if (currentStep == null) {
            return;
        }

        let approver = currentStep.approvers.findWhere({isMe: true});
        new PJQ.views.submittals.WorkflowResponseModal({
            project: this.options.project,
            submittal: this.model,
            approver: approver,
            onSave: () => {
                this.render();
            }
        });
    },
    editWorkflow: function () {
        this.$('.btn-edit-workflow').addClass('hidden');
        this.$('.btn-save-workflow').removeClass('hidden');

        this.workflowView.setEdit(true);
    },
    saveWorkflow: function () {
        this.$('.btn-save-workflow').addClass('hidden');
        this.$('.btn-edit-workflow').removeClass('hidden');

        this.workflowView.setEdit(false);
    },
    viewRevision: function () {
        let lastRevisionId = this.model.get('lastRevisionId');
        if (lastRevisionId == null) {
            return;
        }

        this.removeModal();

        let revision = new PJQ.models.submittals.Submittals({
            submittalId: lastRevisionId
        });
        new PJQ.views.submittals.EditSubmittalModal({
            model: revision,
            project: this.options.project,
            onSave: this.options.onSave,
            onClose: this.options.onClose,
            onDelete: this.options.onDelete
        });
    },
    createRevision: function () {
        this.removeModal();

        let newSubmittal = this.model.clone();
        newSubmittal.set({
            submittalId: null,
            attachments: [],
            comments: [],
            workflow: null,
            submittalNumber: null,
            statusId: null,
            dueDate: null,
            revisionFor: this.model.id,
            isClosed: false
        });
        newSubmittal.attachments = new PJQ.collections.submittals.Attachments();
        newSubmittal.comments = new PJQ.collections.submittals.Comments();

        newSubmittal.workflow = this.model.workflow.clone();

        new PJQ.views.submittals.EditSubmittalModal({
            model: newSubmittal,
            project: this.options.project,
            onSave: this.options.onSave,
            onClose: this.options.onClose,
            onDelete: this.options.onDelete
        });
    },
    closeSubmittal: function () {
        new PJQ.views.submittals.ConfirmSubmittalCloseModal({
            header: "Close Submittal?",
            body: 'Are you sure you want to close this submittal? This will lock the submittal and distribute it to all submittal participants (when selected).',
            statuses: this.options.statuses,
            onConfirm: (opts) => {
                this.model.close(opts, () => {
                    PJQ.notifications.notify.successNotify({
                        message: "Submittal successfully closed" + (opts.distribute ? ' and distributed' : '')
                    });
                    this.render();
                });
            }
        });
    },
    emailSubmittal: function () {
        let projectName = this.options.project?.get('projectName')?.trim(),
            subject = `A Submittal has been shared with you ${projectName && _.size(projectName) > 0 ? `for ${projectName}` : ''}`;
        new PJQ.views.email.ComposeEmailModal({
            project: PJQ.app.session.project,
            header: "Email Submittal",
            enableCC: false,
            subject: subject,
            onSaveWait: (data, cb) => {
                this.model.share(data, _.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Submittal email sent'
                    });

                    cb();
                }, this));
            }
        });
    },
    reopenSubmittal: function () {
        new PJQ.views.modals.YesNo({
            header: "Reopen Submittal?",
            body: 'Are you sure you want to reopen this submittal?',
            onYes: () => {
                this.model.reopen(() => {
                    PJQ.notifications.notify.successNotify({
                        message: "Submittal successfully reopened"
                    });
                    this.render();
                });
            }
        });
    },
    distributeSubmittal: function () {
        new PJQ.views.modals.YesNo({
            header: "Distribute Submittal?",
            body: 'Are you sure you want to distribute this submittal?',
            onYes: () => {
                this.model.distribute(() => {
                    PJQ.notifications.notify.successNotify({
                        message: "Submittal successfully distributed"
                    });
                    this.render();
                });
            }
        });
    },
    voidSubmittal: function (e) {
        if (this.model.get('templateId') != null) {
            return;
        }

        if (!this.validate()) {
            return;
        }

        let status = null;
        if (this.options.isAdmin && e && e.currentTarget != null) {
            statusId = $(e.currentTarget).data('statusId');
            status = this.options.statuses.get(statusId);
        }

        if (status == null) {
            status = this.options.statuses.findWhere({
                type: PJQ.constants.submittals.statusTypes.VOID,
                isDefault: true
            });
        }

        let isNew = this.model.isNew();
        let fnVoid = (comment) => {
            this.model.void(status.id, (success, err) => {
                if (!success) {
                    if (!this.handleStatusError(err)) {
                        let errTxt = 'Encountered an error while voiding the submittal';
                        PJQ.notifications.notify.errorNotify({
                            message: errTxt
                        });
                    }
                    return;
                }

                if (this.options.onSave) {
                    this.options.onSave(this.model, isNew);
                }
                this.render();
            });
        };

        let asNoted = status.get('asNoted');
        this.checkActiveResponse(asNoted, (hadComment) => {
            if (!hadComment && asNoted) {
                new PJQ.views.submittals.StatusChangeCommentModal({
                    model: this.model,
                    title: 'Void Note',
                    onSave: _.bind(function (model, comment) {
                        fnVoid(comment);
                    }, this)
                })
            } else {
                fnVoid();
            }
        });
    },
    addCommentClicked: function () {
        this.addComment();
    },
    addComment: function (asNoted, callback) {
        let val = this.$('.item-new-comment').val().trim();
        if (_.size(val) === 0) {
            callback(false);
            return;
        }

        let comment = new PJQ.models.submittals.Comment({
            submittalId: this.model.id,
            comment: val,
            createdOn: new Date(),
            asNoted: asNoted === true
        });
        if (!this.model.isNew() && !asNoted) {
            comment.save(null, {
                success: _.bind(function () {
                    this.model.comments.add(comment);
                    this.renderComments();
                    if (typeof callback === 'function') {
                        callback(true);
                    }
                }, this)
            });
        } else {
            comment.createdBy = PJQ.app.session.contact ? PJQ.app.session.contact : PJQ.app.session.user;
            this.model.comments.add(comment);
            this.renderComments();
            if (typeof callback === 'function') {
                callback(true);
            }
        }
        this.$('.item-new-comment').val('');
    },
    deleteComment: function (e) {
        let target = $(e.currentTarget),
            $comment = target.closest('.card'),
            cid = $comment.data().cid,
            comment = this.model.comments.get(cid);

        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this comment?",
            onDelete: _.bind(function () {
                this.model.comments.remove(comment);
                comment.destroy();
                this.renderComments();
            }, this)
        });
    },
    renderCustomFields: function () {
        if (_.size(this.options.customFields.models) > 0) {
            this.customFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
                el: this.$('.submittal-custom-fields'),
                collection: this.options.customFields,
                fieldValues: this.model.get('customFieldValues'),
                isEdit: this.options.canEdit,
                onChange: _.bind(function () {
                    this.model.isDirty = true;
                }, this)
            });
        }
    },
    save: function () {
        this.checkActiveResponse(false, () => {
            if (this.fileUploader.isUploading()) {
                new PJQ.views.BaseModal({
                    header: "Files Uploading",
                    body: "You can't save while files are uploading"
                });
            } else {
                let fnDisableButtons = _.bind(function (disable) {
                    this.$('.btn-save').attr('disabled', disable);
                    this.$('.btn-submit').attr('disabled', disable);
                }, this)

                fnDisableButtons(true);
                if (!this.validate()) {
                    fnDisableButtons(false);
                    return;
                }

                PJQ.helpers.inputHelpers.setInputError(this.$('.input-user-company-name'), true);

                let fnSaveAnnotations = (callback) => {
                    _.each(this.changedAnnotations.models, (annotation) => {
                        if (annotation.isNew()) {
                            annotation.set('contextId', this.model.id);
                        }
                    });
                    this.changedAnnotations.saveAll(() => {
                        if (this.options.onSave) {
                            this.options.onSave(this.model, isNew);
                        }

                        let message;
                        if (submitting) {
                            message = 'Submittal submitted successfully';
                        } else {
                            message = 'Submittal saved successfully';
                        }
                        PJQ.notifications.notify.successNotify({
                            message: message
                        });

                        this.removeModal();

                        if (typeof callback === 'function') {
                            callback();
                        }
                    });
                };

                let submitting = this.model.isSubmittedStatus(this.options.statuses) && this.model.initAttributes.statusId !== this.model.get('statusId'),
                    isNew = this.model.isNew();
                if (this.model.hasChanged() || this.model.isNew()) {
                    this.model.save({
                        workflow: this.model.workflow && this.model.workflow.hasChanged() ? this.model.workflow.toJSON() : null,
                    }, {
                        notify: true,
                        success: () => {
                            fnSaveAnnotations();
                        },
                        error: () => {
                            fnDisableButtons(false);
                        }
                    });
                } else {
                    fnSaveAnnotations();
                }
            }
        });
    },
    close: function () {
        if (this.model.hasChanged() && this.model.get('templateId') === null) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.onClose(this.model);
                    this.removeModal();
                }, this)
            });
        } else {
            this.onClose(this.model);
            this.removeModal();
        }
    },
    delete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this Submittal?",
            onDelete: _.bind(function () {
                if (this.options.onDelete) {
                    this.options.onDelete(this.model);
                }
                this.removeModal();
            }, this)
        });
    },
    checkActiveResponse: function (asNoted, callback) {
        let aRes = this.$('.item-new-comment').val();
        if (_.size(aRes) > 0) {
            new PJQ.views.modals.YesNo({
                header: "Post Comment?",
                body: 'You typed a comment but did not click <b>Post Comment</b>.  Would you like to post this comment before continuing?',
                onYes: _.bind(function () {
                    this.addComment(asNoted, (hadComment) => {
                        callback(hadComment);
                    });
                }, this),
                onNo: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(false);
                    }
                }, this)
            });
        } else {
            if (typeof callback === 'function') {
                callback(false);
            }
        }
    },
    submit: function (e) {
        if (this.model.get('templateId') != null) {
            return;
        }

        if (!this.validate()) {
            return;
        }

        let status = null;
        if (e && e.currentTarget != null) {
            statusId = $(e.currentTarget).data('statusId');
            status = this.options.statuses.get(statusId);
        }

        if (status == null) {
            status = this.options.statuses.findWhere({
                type: PJQ.constants.submittals.statusTypes.SUBMITTED,
                isDefault: true
            });
        }

        let isNew = this.model.isNew();
        let fnSubmit = (comment) => {
            this.model.submit(status.id, (success, err) => {
                if (!success) {
                    if (!this.handleStatusError(err)) {
                        let errTxt = 'Encountered an error while submitting the submittal';
                        PJQ.notifications.notify.errorNotify({
                            message: errTxt
                        });
                    }
                    return;
                }

                if (this.options.onSave) {
                    this.options.onSave(this.model, isNew);
                }
                this.render();
            });
        };

        let asNoted = status.get('asNoted');
        this.checkActiveResponse(asNoted, (hadComment) => {
            if (!hadComment && asNoted) {
                new PJQ.views.submittals.StatusChangeCommentModal({
                    model: this.model,
                    title: 'Submission Note',
                    onSave: _.bind(function (model, comment) {
                        fnSubmit(comment);
                    }, this)
                })
            } else {
                fnSubmit();
            }
        });
    },
    reject: function (e) {
        if (this.model.get('templateId') != null) {
            return;
        }

        if (!this.validate()) {
            return;
        }

        let status = null;
        if (this.options.isAdmin && e && e.currentTarget != null) {
            statusId = $(e.currentTarget).data('statusId');
            status = this.options.statuses.get(statusId);
        }

        if (status == null) {
            status = this.options.statuses.findWhere({
                type: PJQ.constants.submittals.statusTypes.REJECTED,
                isDefault: true
            });
        }

        let isNew = this.model.isNew();
        let fnReject = (comment) => {
            this.model.reject(status.id, (success, err) => {
                if (!success) {
                    if (!this.handleStatusError(err)) {
                        let errTxt = 'Encountered an error while rejecting the submittal';
                        PJQ.notifications.notify.errorNotify({
                            message: errTxt
                        });
                    }
                    return;
                }

                if (this.options.onSave) {
                    this.options.onSave(this.model, isNew);
                }
                this.render();
            });
        };

        let asNoted = status.get('asNoted');
        this.checkActiveResponse(asNoted, (hadComment) => {
            if (!hadComment && asNoted) {
                new PJQ.views.submittals.StatusChangeCommentModal({
                    model: this.model,
                    title: 'Rejection Note',
                    onSave: _.bind(function (model, comment) {
                        fnReject(comment);
                    }, this)
                })
            } else {
                fnReject();
            }
        });
    },
    validate: function () {
        PJQ.helpers.inputHelpers.setInputError(this.$('.input-due-date'), true);
        let dueDateVal = this.$('.input-due-date').val().trim();

        if (_.size(dueDateVal) === 0) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.input-due-date'), false);
            return false;
        }

        if (this.managerPicker != null && !this.managerPicker.validate() && this.options.isAdmin) {
            return false;
        }

        if (this.customFieldsForm && !this.customFieldsForm.validate()) {
            return false;
        }

        return true
    },
    approve: function (e) {
        if (this.model.get('templateId') != null) {
            return;
        }

        if (!this.validate()) {
            return;
        }

        let status = null;
        if (e && e.currentTarget != null) {
            statusId = $(e.currentTarget).data('statusId');
            status = this.options.statuses.get(statusId);
        }

        if (status == null) {
            status = this.options.statuses.findWhere({
                type: PJQ.constants.submittals.statusTypes.APPROVED,
                isDefault: true
            });
        }

        let isNew = this.model.isNew();
        let fnApprove = (comment) => {
            // todo: save comment
            this.model.approve(status.id, null, (success, err) => {
                if (!success) {
                    if (!this.handleStatusError(err)) {
                        let errTxt = 'Encountered an error while approving the submittal';
                        PJQ.notifications.notify.errorNotify({
                            message: errTxt
                        });
                    }
                    return;
                }

                if (this.options.onSave) {
                    this.options.onSave(this.model, isNew);
                }
                this.render();
            });
        };

        let asNoted = status.get('asNoted');
        this.checkActiveResponse(asNoted, (hadComment) => {
            if (!hadComment && asNoted) {
                new PJQ.views.submittals.StatusChangeCommentModal({
                    model: this.model,
                    title: 'Approval Note',
                    onSave: _.bind(function (model, comment) {
                        fnApprove(comment);
                    }, this)
                });
            } else {
                fnApprove();
            }

        });
    },
    handleStatusError: function (err) {
        if (err !== PJQ.constants.submittals.errors.STATUS_NOT_EXISTS) {
            return false;
        }

        let fObj = this.options.project != null ? this.options.project : PJQ.app.session;
        fObj.fetchSubmittalStatuses(true).then((st) => {
            this.options.statuses = st;
            this.render();
        });

        PJQ.notifications.notify.errorNotify({
            message: 'The status you selected no longer exists, please select a different status'
        });
        return true;
    },
    editFile: function (file) {
        new PJQ.views.submittals.FileEditorModal({
            model: file,
            collection: new PJQ.collections.submittals.Attachments(),
            isNewVersion: true,
            onSave: _.bind(function (file) {
                let newFile = file.models[0];
                if (file.models[1].get('submittalDocumentId') === file.models[1].get('parentSubmittalDocumentId')) {
                    newFile.attributes.parentSubmittalDocumentId = file.models[1].get('submittalDocumentId');
                } else {
                    newFile.attributes.parentSubmittalDocumentId = file.models[1].get('parentSubmittalDocumentId');
                }
                _.each(this.model.attachments.models, function (model) {
                    if (model.get('submittalDocumentId') === file.models[1].get('submittalDocumentId')) {
                        model.attributes = newFile.attributes;
                    }
                }, this);
                this.model.isDirty = true;
            }, this)
        });
    },
    uploadFile: function () {
        new PJQ.views.submittals.FileEditorModal({
            collection: new PJQ.collections.submittals.Attachments(),
            isNewVersion: false,
            onSave: _.bind(function (files) {
                _.each(files.models, function (model) {
                    model.attributes.createdOn = new Date();
                    model.attributes.createdByDisplay = model.get('createdBy').contactName;
                    model.attributes.notes = "";
                    model.attributes.versionNumber = 1;
                    this.model.attachments.add(model);
                }, this);
                this.model.isDirty = true;
            }, this)
        });
    },
    editNoteClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.filesTable.getRow(target.closest('tr'));
        this.editNote(row);
    },
    editNote: function (file) {
        new PJQ.views.submittals.FileEditorModal({
            model: file,
            isNoteEdit: true,
            collection: new PJQ.collections.submittals.Attachments(),
            isNewVersion: true,
            onSave: _.bind(function () {
                this.model.isDirty = true;
                // this.filesTable.render();
            }, this)
        });
    },
    viewNotificationHistory: function () {
        this.model.fetchNotifications(function (notifications) {
            new PJQ.views.notifications.NotificationHistory({
                collection: notifications
            });
        })
    },
    viewEditHistory: function () {
        this.model.fetchEditHistory(function (editHistory) {
            new PJQ.views.submittals.EditHistoryModal({
                history: editHistory
            })
        })
    },
    exportSubmittal: function () {
        new PJQ.ajax.Request({
            endpoint: this.options.project.endpoint() + '/submittals/' + this.model.get('submittalId') + '/export',
            data: {
                isApi2: true
            }
        }).post().done(_.bind(function (response) {
            PJQ.files.downloadFile(response.url, {
                isEndpoint: false
            });
        }, this)).fail(_.bind(function (xhr, err, result) {
        }, this));
    },
    downloadAttachment: function (e) {
        let $target = $(e.currentTarget),
            cid = $target.data('cid'),
            attachment = null;
        for (let i = 0; i < this.model.attachments.models.length; i++) {
            let sAttachment = this.model.attachments.models[i];
            if (sAttachment.cid === cid) {
                attachment = sAttachment;
            } else if (sAttachment.versions != null) {
                for (let j = 0; j < sAttachment.versions.models.length; j++) {
                    let ver = sAttachment.versions.models[j];
                    if (ver.cid === cid) {
                        attachment = ver;
                    }
                }
            }

            if (attachment != null) {
                break;
            }
        }
        if (attachment != null) {
            attachment.download();
        }
    },
    downloadAllAttachments: function () {
        this.options.project.downloadAttachments(_.map(this.model.attachments.models, function (attachment) {
            return new PJQ.models.files.File({
                entryId: attachment.get('entryId'),
                guid: attachment.get('guid')
            });
        }));
    }
});

PJQ.views.submittals.ConfirmSubmittalCloseModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'modal-close-submittal'),
        statuses: null
    },
    events: {
        'click .btn-confirm': 'onConfirm',
        'change .cb-distribute': 'onDistributeChange'
    },
    beforeModalCreated: function () {
        this.distribute = true;
    },
    renderData: function () {
        return {
            distribute: this.distribute,
            statuses: this.options.statuses
        };
    },
    afterRender: function () {
        this.selectedStatus = -1;
        if (this.options.statuses != null) {
            this.statusPicker = new PJQ.inputs.Selectpicker({
                el: this.$('.select-status'),
                defaultValue: this.selectedStatus,
                isIntChoices: true,
                choices: _.union([{
                    id: -1,
                    name: 'Closed'
                }], _.map(_.filter(this.options.statuses.models, (st) => {
                    let tp = st.get('type');
                    return tp === PJQ.constants.submittals.statusTypes.APPROVED
                        || tp === PJQ.constants.submittals.statusTypes.REJECTED;
                }), (st) => {
                    return {
                        id: st.id,
                        name: st.get('name')
                    };
                })),
                onChange: (value) => {
                    this.selectedStatus = value;
                }
            });
        }
    },
    onDistributeChange: function () {
        this.distribute = this.$('.cb-distribute').prop('checked');
        this.render();
    },
    onConfirm: function () {
        if (typeof this.options.onConfirm === 'function') {
            this.options.onConfirm({
                distribute: this.distribute,
                status: this.selectedStatus
            });
        }
        this.removeModal();
    }
});
PJQ.models.submittals.Submittals = PJQ.models.BaseModel.extend({
    idAttribute: "submittalId",
    endpoint: function (urlOptions) {
        let arr;
        if (this.isNew() && this.get('projectId') > 0) {
            arr = [
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'submittals',
                    value: this.id
                }
            ];
        } else if (this.isNew() && this.get('templateId') > 0) {
            arr = [
                {
                    endpoint: 'submittals'
                },
                {
                    endpoint: 'templates',
                    value: this.get('templateId')
                },
                {
                    endpoint: 'submittals'
                }
            ];
        } else {
            arr = [
                {
                    endpoint: 'submittals',
                    value: this.id
                }
            ];
        }

        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    },
    afterInit: function () {
        if (this.get('customFieldValues') == null) {
            this.set('customFieldValues', [], {
                silent: true
            });
        }
    },
    parse: function (model) {
        model = _.defaults(model, {});

        if (_.size(model.itemTypes) > 0) {
            this.itemTypes = new PJQ.collections.submittals.ItemTypes(model.itemTypes);
        } else if (!this.groups) {
            this.itemTypes = new PJQ.collections.submittals.ItemTypes();
        }

        if (_.size(model.groups) > 0) {
            this.groups = new PJQ.collections.groups.Groups(model.groups);
        } else if (!this.groups) {
            this.groups = new PJQ.collections.groups.Groups();
        }

        if (model.createdBy != null) {
            this.createdBy = new PJQ.models.projectContacts.ProjectContact(model.createdBy);
        } else {
            this.createdBy = null;
        }

        if (model.ballInCourt != null) {
            this.ballInCourt = new PJQ.models.projectContacts.ProjectContact(model.ballInCourt);
        } else {
            this.ballInCourt = null;
        }

        if (model.submitter != null) {
            this.submitter = new PJQ.models.projectContacts.ProjectContact(model.submitter);
        } else {
            this.submitter = null;
        }

        if (model.manager != null) {
            this.manager = new PJQ.models.projectContacts.ProjectContact(model.manager);
        } else {
            this.manager = null;
        }

        this.workflow = new PJQ.models.submittals.Workflow(model.workflow);

        // this.approvers = new PJQ.collections.projectContacts.ProjectContacts(model.approvers);

        if (_.size(model.distributionList) > 0) {
            this.distributionList = new PJQ.collections.projectContacts.ProjectContacts(model.distributionList);
        } else if (!this.distributionList) {
            this.distributionList = new PJQ.collections.projectContacts.ProjectContacts();
        }

        if (_.size(model.comments) > 0) {
            this.comments = new PJQ.collections.submittals.Comments(model.comments);
        } else if (!this.comments) {
            this.comments = new PJQ.collections.submittals.Comments();
        }

        if (_.size(model.attachments) > 0) {
            this.attachments = new PJQ.collections.submittals.Attachments(model.attachments);
        } else if (!this.attachments) {
            this.attachments = new PJQ.collections.submittals.Attachments();
        }

        return model;
    },
    statusShouldLock: function (statuses) {
        let statusId = this.get('statusId'),
            status = statuses.get(statusId);
        return status && status.get('shouldLock');
    },
    isNewStatus: function (statuses) {
        let statusId = this.get('statusId'),
            status = statuses.get(statusId);
        return status && status.get('type') === PJQ.constants.submittals.statusTypes.NEW;
    },
    isSubmittedStatus: function (statuses) {
        let statusId = this.get('statusId'),
            status = statuses.get(statusId);
        return status && status.get('type') === PJQ.constants.submittals.statusTypes.SUBMITTED;
    },
    isApprovedStatus: function (statuses) {
        let statusId = this.get('statusId'),
            status = statuses.get(statusId);

        if (status.get('type') === PJQ.constants.submittals.statusTypes.SUBMITTED) {
            // todo: check for submitted status type & partially approved
        }

        return status && status.get('type') === PJQ.constants.submittals.statusTypes.APPROVED;
    },
    isRejectedStatus: function (statuses) {
        let statusId = this.get('statusId'),
            status = statuses.get(statusId);
        return status && status.get('type') === PJQ.constants.submittals.statusTypes.REJECTED;
    },
    isVoidStatus: function (statuses) {
        let statusId = this.get('statusId'),
            status = statuses.get(statusId);
        return status && status.get('type') === PJQ.constants.submittals.statusTypes.VOID;
    },
    isPartiallyApproved: function () {
        return null != _.find(this.get('approvers'), (approver) => {
            return !approver.hasApproved;
        }) && null != _.find(this.get('approvers'), (approver) => {
            return approver.hasApproved;
        });
    },
    getStatusColor: function (statuses) {
        let statusId = this.get('statusId'),
            status = statuses.get(statusId),
            statusType = status.get('type');
        if (status == null) {
            // should never ever happen
            return '#000000';
        } else if (this.get('isClosed') && statusType === PJQ.constants.submittals.statusTypes.SUBMITTED) {
            return PJQ.constants.colors.GRAY;
        }

        if (statusType === PJQ.constants.submittals.statusTypes.SUBMITTED && this.isPartiallyApproved()) {
            return PJQ.constants.colors.PURPLE;
        }

        return PJQ.constants.submittals.statusTypeColors[status.get('type')];
    },
    getStatusName: function (settings, statuses, options = {}) {
        let statusId = this.get('statusId'),
            status = statuses.get(statusId),
            statusType = status.get('type');
        if (status == null) {
            // should never ever happen
            return 'New';
        } else if (this.get('isClosed') && statusType === PJQ.constants.submittals.statusTypes.SUBMITTED) {
            return 'Closed';
        }

        let result = status.get('name');
        if (statusType === PJQ.constants.submittals.statusTypes.SUBMITTED && this.isPartiallyApproved()) {
            let approveStatusName = settings.getApproveStatusName('ed');
            return 'Partially ' + approveStatusName;
        }

        // todo: add 'as noted" if asNoted is enabled and asNotedCommentId is set
        if (status.get('asNoted') && this.get('asNotedCommentId') > 0 && (!options || options.includeAsNoted !== false) && -1 === result.toLowerCase().indexOf("as noted")) {
            result += ' as noted';
        }

        return result;
    },
    beforeSave: function () {
        this.set({
            groups: this.groups.toJSON(),
            itemTypes: this.itemTypes.toJSON(),
            submitter: this.submitter ? this.submitter.toJSON() : null,
            manager: this.manager ? this.manager.toJSON() : null,
            // approvers: this.approvers.toJSON(),
            distributionList: this.distributionList.toJSON(),
            attachments: this.attachments.toJSON(),
            comments: this.comments.toJSON()
        });
    },
    approve: function (status, behalfId, callback) {
        this.beforeSave();

        let ep = this.endpoint() + '/approve';
        if (behalfId && behalfId != 0) {
            ep += '?behalf=' + behalfId.toString();
        }
        if (status && status != 0) {
            ep += '?approveStatus=' + status.toString();
        }
        new PJQ.ajax.Request({
            endpoint: ep,
            data: this.toJSON()
        }).post().done((response) => {
            this.reset(response);
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((res) => {
            let err = null;
            if (res.responseJSON && res.responseJSON.message) {
                err = res.responseJSON.message;
            }
            if (typeof callback === 'function') {
                callback(false, err);
            }
        });
    },
    void: function (status, callback) {
        let prevStatus = this.get('statusId');
        if (status > 0) {
            this.set('statusId', status);
        }

        this.beforeSave();
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/void',
            data: this.toJSON()
        }).post().done(_.bind(function (response) {
            this.reset(response);
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail((res) => {
            this.set('statusId', prevStatus);

            let err = null;
            if (res.responseJSON && res.responseJSON.message) {
                err = res.responseJSON.message;
            }
            if (typeof callback === 'function') {
                callback(false, err);
            }
        });
    },
    reject: function (status, callback) {
        let prevStatus = this.get('statusId');
        if (status > 0) {
            this.set('statusId', status);
        }

        this.beforeSave();
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/reject',
            data: this.toJSON()
        }).post().done(_.bind(function (response) {
            this.reset(response);
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail((res) => {
            this.set('statusId', prevStatus);

            let err = null;
            if (res.responseJSON && res.responseJSON.message) {
                err = res.responseJSON.message;
            }
            if (typeof callback === 'function') {
                callback(false, err);
            }
        });
    },
    submit: function (status, callback) {
        let prevStatus = this.get('statusId');
        if (status > 0) {
            this.set('statusId', status);
        }

        this.beforeSave();
        if (this.id > 0) {
            new PJQ.ajax.Request({
                endpoint: this.endpoint() + '/submit',
                data: this.toJSON()
            }).post().done(_.bind(function (response) {
                this.reset(response);
                if (typeof callback === 'function') {
                    callback(true);
                }
            }, this)).fail((res) => {
                this.set('statusId', prevStatus);

                let err = null;
                if (res.responseJSON && res.responseJSON.message) {
                    err = res.responseJSON.message;
                }
                if (typeof callback === 'function') {
                    callback(false, err);
                }
            });
        } else {
            this.save(null, {
                notify: false,
                success: function () {
                    if (typeof callback === 'function') {
                        callback(true);
                    }
                },
                error: (model, res) => {
                    this.set('statusId', prevStatus);

                    let err = null;
                    if (res.responseJSON && res.responseJSON.message) {
                        err = res.responseJSON.message;
                    }

                    if (typeof callback === 'function') {
                        callback(false, err);
                    }
                }
            })
        }
    },
    respond: function (response, behalfId, callback) {
        this.beforeSave();

        let ep = this.endpoint() + '/respond';
        if (behalfId && behalfId != 0) {
            ep += '?behalf=' + behalfId.toString();
        }

        new PJQ.ajax.Request({
            endpoint: ep,
            data: response.toJSON()
        }).post().done((response) => {
            this.reset(response);
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((res) => {
            let err = null;
            if (res.responseJSON && res.responseJSON.message) {
                err = res.responseJSON.message;
            }
            if (typeof callback === 'function') {
                callback(false, err);
            }
        });
    },
    setBallInCourt: function (stepId, callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/ballincourt' + '?stepId=' + stepId
        }).post().done((response) => {
            this.reset(response);
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((res) => {
            let err = null;
            if (res.responseJSON && res.responseJSON.message) {
                err = res.responseJSON.message;
            }
            if (typeof callback === 'function') {
                callback(false, err);
            }
        });
    },
    close: function (opts, callback) {
        let qs = '?distribute=' + (opts.distribute === true).toString();
        if (opts.status && opts.status > 0) {
            qs += '&statusId=' + opts.status.toString();
        }
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/close' + qs,
        }).post().done((response) => {
            this.reset(response);
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((res) => {
            let err = null;
            if (res.responseJSON && res.responseJSON.message) {
                err = res.responseJSON.message;
            }
            if (typeof callback === 'function') {
                callback(false, err);
            }
        });
    },
    reopen: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/reopen',
        }).post().done((response) => {
            this.reset(response);
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((res) => {
            let err = null;
            if (res.responseJSON && res.responseJSON.message) {
                err = res.responseJSON.message;
            }
            if (typeof callback === 'function') {
                callback(false, err);
            }
        });
    },
    distribute: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/distribute',
        }).post().done((response) => {
            this.reset(response);
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((res) => {
            let err = null;
            if (res.responseJSON && res.responseJSON.message) {
                err = res.responseJSON.message;
            }
            if (typeof callback === 'function') {
                callback(false, err);
            }
        });
    },
    share: function (data, callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/email',
            data: {
                subject: data != null ? data.subject : null,
                body: data != null ? data.body : null,
                toEmails: data != null ? data.toEmails : null,
                ccEmails: data != null ? data.ccEmails : null,
            }
        }).post().done(_.bind(function (response) {
            callback();
        }, this)).fail(_.bind(function (xhr, err, result) {
            //todo: error
        }, this));
    },
    isUserCurrentApprover: function (approvalMode, user) {
        if (!user) {
            if (approvalMode === PJQ.constants.submittals.approvalModes.SEQUENTIAL) {
                return this.get('isNextApprover') && !this.get('hasApproved');
            }

            return this.get('isApprover') && !this.get('hasApproved');
        }

        let result = false;
        if (approvalMode === PJQ.constants.submittals.approvalModes.SEQUENTIAL) {
            let foundNextApprover = false;
            _.each(this.get('approvers'), function (approver) {
                if (foundNextApprover || approver.hasApproved) {
                    return;
                }

                if (approver.id === user.get('id')) {
                    result = true;
                }
                foundNextApprover = true;
            })
        } else {
            result = null != _.findWhere(this.get('approvers'), {id: user.get('id'), hasApproved: false});
        }
        return result;
    },
    getRemainingApprovers: function () {
        return _.filter(this.get('approvers'), (approver) => {
            return !approver.hasApproved;
        })
    },
    isLastApprover: function (approvalMode, user) {
        if (!user) {
            if (approvalMode === PJQ.constants.submittals.approvalModes.SEQUENTIAL) {
                return _.size(this.get('approvers')) === 0 || this.get('isLastApprover');
            }

            return _.size(this.getRemainingApprovers()) <= 1;
        }

        return _.indexOf(this.get('approvers'), user.get('id')) === this.get('approvers').length - 1;
    },
    fetchNotifications: function (callback) {
        if (this.notifications == null) {
            this.notifications = new PJQ.collections.submittals.Notifications(null, {
                submittal: this
            })
        }

        this.notifications.fetch({
            success: _.bind(function () {
                callback(this.notifications);
            }, this)
        });
    },
    fetchEditHistory: function (callback) {
        if (this.editHistory == null) {
            this.editHistory = new PJQ.collections.submittals.EditHistory(null, {
                submittal: this
            })
        }

        this.editHistory.fetch({
            success: _.bind(function () {
                callback(this.editHistory);
            }, this)
        });
    },
});

PJQ.models.submittals.Attachment = PJQ.models.files.File.extend({
    idAttribute: 'attachmentId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'submittals',
                value: this.get('submittalId')
            },
            {
                endpoint: 'attachments',
                value: this.id
            }
        ]);
    }
});

PJQ.models.submittals.WorkflowTemplate = PJQ.models.BaseModel.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('projectId')
            },
            {
                endpoint: 'submittals'
            },
            {
                endpoint: 'workflows',
                value: this.id
            }
        ]);
    },
    parse: function (model) {
        if (model == null) {
            model = {};
        }

        this.workflow = new PJQ.models.submittals.Workflow(model.workflow);
        return model;
    },
    beforeSave: function () {
        this.set({
            workflow: this.workflow.toJSON()
        });
    },
});

PJQ.models.submittals.Workflow = PJQ.models.BaseModel.extend({
    parse: function (model) {
        if (model == null) {
            model = {};
        }

        this.steps = new PJQ.collections.submittals.WorkflowSteps(model.steps);

        return model;
    },
    clone: function () {
        let cloned = PJQ.models.BaseModel.prototype.clone.call(this);
        cloned.set({
            submittalId: null,
            templateId: null
        });
        _.each(cloned.steps.models, (step) => {
            step.set({
                id: null,
                isActive: false
            })

            let newApprovers = _.map(step.approvers.models, (approver) => {
                return {
                    stepId: approver.get('stepId'),
                    person: approver.get('person'),
                    personId: approver.get('personId'),
                    isRequired: approver.get('isRequired'),
                }
            });
            step.approvers.reset(newApprovers);
        });
        return cloned;
    },
    beforeSave: function () {
        this.set('steps', this.steps.toJSON());
    },
    toJSON: function () {
        this.beforeSave();
        return PJQ.models.BaseModel.prototype.toJSON.call(this);
    },
    getCurrentStep: function () {
        return this.steps.findWhere({isActive: true});
    },
    getAllApprovers: function () {
        let result = [];
        _.each(this.steps.models, (step) => {
            result.push(...step.approvers.models);
        });
        return result;
    }
});

PJQ.models.submittals.WorkflowStep = PJQ.models.BaseModel.extend({
    parse: function (model) {
        model = _.defaults(model, {});

        this.approvers = new PJQ.collections.submittals.WorkflowApprovers(model.approvers);

        return model;
    },
    beforeSave: function () {
        this.set('approvers', this.approvers.toJSON());
    },
    toJSON: function () {
        this.beforeSave();
        return PJQ.models.BaseModel.prototype.toJSON.call(this);
    }
});

PJQ.models.submittals.WorkflowApprover = PJQ.models.BaseModel.extend({});

PJQ.models.submittals.WorkflowResponse = PJQ.models.BaseModel.extend({
    parse: function (model) {
        model = _.defaults(model, {});

        this.attachments = new PJQ.collections.submittals.Attachments(model.attachments);

        return model;
    },
    beforeSave: function () {
        this.set({
            attachments: this.attachments.toJSON()
        });
    },
    toJSON: function () {
        this.beforeSave();
        return PJQ.models.BaseModel.prototype.toJSON.call(this);
    }
});

PJQ.models.submittals.Notification = PJQ.models.notifications.Notification.extend({
    notificationTypeNames: PJQ.constants.submittals.notificationTypeNames,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'submittals',
                value: this.collection.options.submittal.id
            },
            {
                endpoint: 'notifications',
                value: this.id
            }
        ])
    }
});

PJQ.models.submittals.Comment = PJQ.models.BaseModel.extend({
    notifyName: 'Comment',
    idAttribute: 'commentId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'submittals',
                value: this.get('submittalId')
            },
            {
                endpoint: 'comments',
                value: this.id
            }
        ]);
    }
});

PJQ.models.submittals.EditHistoryItem = PJQ.models.BaseModel.extend({
    idAttribute: 'auditId'
});

PJQ.models.submittals.ItemType = PJQ.models.BaseModel.extend({
    idAttribute: 'itemTypeId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'submittals'
            },
            {
                endpoint: 'itemtypes',
                value: this.id
            }
        ]);
    }
});

PJQ.models.submittals.Settings = PJQ.models.BaseModel.extend({
    idAttribute: 'settingId',
    endpoint: function () {
        if (this.get('projectId') > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'submittals'
                },
                {
                    endpoint: 'settings'
                }
            ]);
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'submittals'
            },
            {
                endpoint: 'settings'
            }
        ]);
    },
    parse: function (model) {
        model = _.defaults(model, {});

        if (model) {
            if (_.size(model.defaultDistributionList) > 0) {
                this.defaultDistributionList = new PJQ.collections.projectContacts.ProjectContacts(model.defaultDistributionList);
            } else if (!this.defaultDistributionList) {
                this.defaultDistributionList = new PJQ.collections.projectContacts.ProjectContacts();
            }

            if (model.defaultManager != null) {
                this.defaultManager = new PJQ.models.projectContacts.ProjectContact(model.defaultManager);
            } else {
                this.defaultManager = null;
            }
        }

        return model;
    },
    beforeSave: function () {
        this.set({
            defaultManager: this.defaultManager ? this.defaultManager.toJSON() : null,
            defaultDistributionList: this.defaultDistributionList.toJSON()
        });
    },
    getApproveStatusName: function (suffix) {
        let statusName = this.get('approveNameOverride');
        if (_.size(statusName) === 0) {
            statusName = "Approve";
        }

        if (_.size(suffix) > 0) {
            // if suffix starts with "e", and status name ends with "e"
            // trim the preceding "e" from the suffix
            if (suffix[0].toLowerCase() === "e" && statusName[statusName.length - 1].toLowerCase() === "e") {
                suffix = suffix.substring(1);
            }

            statusName += suffix;
        }

        return statusName;
    }
});

PJQ.models.submittals.Status = PJQ.models.BaseModel.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'submittals'
            },
            {
                endpoint: 'statuses',
                value: this.id
            }
        ]);
    }
});

PJQ.models.submittals.SubmittalUserSettings = PJQ.models.BaseModel.extend({
    endpoint: function () {
        let params = [];
        if (this.options.forCompany) {
            params.push({
                parameter: 'forCompany',
                value: true
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'submittals'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'user'
            }
        ], params);
    },
    getSettings: function (view) {
        return _.find(this.attributes.viewSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));
    }
});

PJQ.models.submittals.SubmittalCustomField = PJQ.models.customFields.CustomField.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'submittals'
            },
            {
                endpoint: 'customFields',
                value: this.id
            }
        ]);
    },
});

PJQ.models.submittals.Template = PJQ.models.BaseModel.extend({
    idAttribute: 'templateId',
    notifyName: 'Template',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'submittals'
            },
            {
                endpoint: 'templates',
                value: this.id
            }
        ], this.get('projectId') > 0 ? [
            {
                parameter: 'projectId',
                value: this.get('projectId')
            },
            {
                parameter: 'copyComments',
                value: this.get('copyComments')
            },
            {
                parameter: 'copySubmitter',
                value: this.get('copySubmitter')
            },
            {
                parameter: 'copyApprovers',
                value: this.get('copyApprovers')
            },
            {
                parameter: 'copyGroups',
                value: this.get('copyGroups')
            },
            {
                parameter: 'copyDistribution',
                value: this.get('copyDistribution')
            },
            {
                parameter: 'copyItemTypes',
                value: this.get('copyItemTypes')
            },
            {
                parameter: 'overwrite',
                value: this.get('overwrite')
            }
        ] : null);
    },
    parse: function (model) {
        if (!model)
            return model;

        if (model.project != null) {
            this.project = model.project;
        } else {
            this.user = PJQ.app.session.user;
        }

        this.itemTypes = new PJQ.collections.submittals.ItemTypes(model.itemTypes);

        this.groups = new PJQ.collections.groups.Groups(model.groups);

        if (model.createdBy != null) {
            this.createdBy = new PJQ.models.projectContacts.ProjectContact(model.createdBy);
        } else {
            this.createdBy = null;
        }

        if (model.ballInCourt != null) {
            this.ballInCourt = new PJQ.models.projectContacts.ProjectContact(model.ballInCourt);
        } else {
            this.ballInCourt = null;
        }

        if (model.submitter != null) {
            this.submitter = new PJQ.models.projectContacts.ProjectContact(model.submitter);
        } else {
            this.submitter = null;
        }

        this.approvers = new PJQ.collections.projectContacts.ProjectContacts(model.approvers);

        this.distributionList = new PJQ.collections.projectContacts.ProjectContacts(model.distributionList);

        this.comments = new PJQ.collections.submittals.Comments(model.comments);

        this.attachments = new PJQ.collections.submittals.Attachments(model.attachments);

        if (model.submittals)
            this.submittals = new PJQ.collections.submittals.Submittals(model.submittals);

        else
            this.submittals = new PJQ.collections.submittals.Submittals();

        return model;
    }
});

PJQ.collections.submittals = {};
PJQ.collections.submittals.Submittals = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.submittals.Submittals,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'submittals'
            }
        ])
    }
});

PJQ.collections.submittals.WorkflowTemplates = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.submittals.WorkflowTemplate,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'submittals'
            },
            {
                endpoint: 'workflows'
            }
        ]);
    }
});

PJQ.collections.submittals.WorkflowSteps = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.submittals.WorkflowStep
});

PJQ.collections.submittals.WorkflowApprovers = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.submittals.WorkflowApprover
});

PJQ.collections.submittals.Attachments = PJQ.collections.files.Files.extend({
    model: PJQ.models.submittals.Attachment,
});

PJQ.collections.submittals.Comments = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.submittals.Comment
});

PJQ.collections.submittals.EditHistory = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.submittals.EditHistoryItem,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'submittals',
                value: this.options.submittal.id
            },
            {
                endpoint: 'edithistory'
            }
        ]);
    }
});

PJQ.collections.submittals.ItemTypes = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.submittals.ItemType,
    endpoint: function () {
        if (this.options.project != null) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'submittals'
                },
                {
                    endpoint: 'itemTypes'
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'submittals'
                },
                {
                    endpoint: 'itemTypes'
                }
            ]);
        }

    }
});

PJQ.collections.submittals.Statuses = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.submittals.Status,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'submittals'
                },
                {
                    endpoint: 'statuses'
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'submittals'
                },
                {
                    endpoint: 'statuses'
                }
            ]);
        }
    },
    copy: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'submittals'
                },
                {
                    endpoint: 'statuses'
                },
                {
                    endpoint: 'copy'
                }
            ])
        }).post().done(_.bind(function (response) {
            callback(response);
        }, this));
    },
});

PJQ.collections.submittals.Notifications = PJQ.collections.notifications.Notifications.extend({
    model: PJQ.models.submittals.Notification,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'submittals',
                value: this.options.submittal.id
            },
            {
                endpoint: 'notifications'
            }
        ])
    }
});

PJQ.collections.submittals.SubmittalCustomFields = PJQ.collections.customFields.CustomFields.extend({
    model: PJQ.models.submittals.SubmittalCustomField,
    options: {
        masterUserId: null
    },
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project ? this.options.project.id : null
            },
            {
                endpoint: 'submittals'
            },
            {
                endpoint: 'customFields'
            }
        ], [
            {
                parameter: 'masterUserId',
                value: this.options.masterUserId > 0 ? this.options.masterUserId : PJQ.app.session.get('masterUserId')
            }
        ]);
    }
});

PJQ.collections.submittals.SubmittalCustomField = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.submittals.SubmittalCustomField,
    options: {
        masterUserId: null
    },
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'submittals'
                },
                {
                    endpoint: 'customFields'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'submittals'
                },
                {
                    endpoint: 'customFields'
                }
            ],
            [
                {
                    parameter: 'masterUserId',
                    value: this.options.masterUserId > 0 ? this.options.masterUserId : PJQ.app.session.get('masterUserId')
                }
            ]);
    }
});

PJQ.collections.submittals.Templates = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.submittals.Template,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'submittals'
            },
            {
                endpoint: 'templates'
            }
        ]);
    }
});
PJQ.views.submittals.SubmittalsView = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'submittals-management'),
        initSubmittalId: null
    },
    events: {
        'click .btn-delete-submittal': 'deleteClicked',
        'click .btn-edit-submittal': 'editClicked',
        'click .btn-add-submittal': 'addClicked',
        'click .export-detailed': 'exportSubmittals',
        'click .export-list': 'exportList',
        'click .btn-submittal-settings': 'editSettings',
        'click .btn-save-a-template': 'saveTemplate',
        'click .btn-import-template': 'importTemplate'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;
        this.preferences = this.options.project ? this.options.project.preferences : PJQ.app.session.preferences;

        this.options.userSettings = await PJQ.app.session.fetchSubmittalUserSettings();
        if (this.options.project) {
            this.options.settings = await this.options.project.fetchSubmittalSettings();
            this.options.itemTypes = await this.options.project.fetchSubmittalItemTypes();
            this.options.customFields = await this.options.project.fetchSubmittalCustomFields();
            this.options.statuses = await this.options.project.fetchSubmittalStatuses();
        } else {
            this.options.settings = await PJQ.app.session.fetchSubmittalSettings();
            this.options.itemTypes = await PJQ.app.session.fetchSubmittalItemTypes();
            this.options.customFields = await PJQ.app.session.fetchSubmittalCustomFields();
            this.options.statuses = await PJQ.app.session.fetchSubmittalStatuses();
        }

        if (this.collection == null && this.options.project != null) {
            this.collection = new PJQ.collections.submittals.Submittals(null, {
                project: this.options.project
            });
            await this.collection.fetch();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        this.options.canAdd = this.options.project ? this.options.project.hasPermission('submittals.canAdd') : PJQ.app.session.hasPermission('settings.canManageSubmittals');
        this.options.isAdmin = this.options.project ? this.options.project.hasPermission('submittals.isAdmin') : PJQ.app.session.hasPermission('settings.canManageSubmittals');
    },
    renderData: function () {
        return {
            project: this.options.project,
            statuses: this.options.statuses
        };
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.renderDataTable();

        if (this.options.initSubmittalId > 0) {
            let initSubmittal = this.collection.get(this.options.initSubmittalId);
            if (initSubmittal != null) {
                this.options.initSubmittalId = null;
                this.editSubmittal(initSubmittal);
            }
        }
    },
    renderDataTable: function () {
        let self = this;
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".submittals-table"),
            data: this.collection.models,
            rowId: "cid",
            order: [[2, 'desc']],
            pageLength: this.options.userSettings.getSettings(PJQ.constants.submittals.view.SUBMITTALS).rowsPerPage,
            orderCookie: PJQ.constants.cookies.SUBMITTAL_ORDER_COOKIE,
            settings: this.options.userSettings.getSettings(PJQ.constants.submittals.view.SUBMITTALS),
            language: {
                zeroRecords: 'Click "Add New Submittal" to create a new Submittal'
            },
            subTemplates: {
                header: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'Data-Table-Header-submittals')
            },
            headerData: () => {
                return {
                    canAdd: this.options.canAdd,
                    project: this.options.project,
                    statuses: this.options.statuses
                };
            },
            afterHeaderRender: (view, $header) => {
                let statuses = [],
                    addedPartial = false;
                _.each(_.sortBy(this.options.statuses.models, (status) => {
                    return status.get('sortOrder')
                }), (status) => {
                    if (this.options.settings.get('enableWorkflow')) {
                        if (status.get('type') !== PJQ.constants.submittals.statusTypes.SUBMITTED
                            && status.get('type') !== PJQ.constants.submittals.statusTypes.NEW) {
                            return;
                        }

                        statuses.push({
                            id: status.get('id'),
                            name: status.get('name'),
                            style: 'color: ' + PJQ.constants.submittals.statusTypeColors[status.get('type')]
                        });
                        return;
                    }

                    if (status.get('type') === PJQ.constants.submittals.statusTypes.APPROVED && !addedPartial) {
                        statuses.push({
                            id: '-1',
                            name: 'Partially Approved',
                            style: 'color: ' + PJQ.constants.colors.PURPLE
                        });
                        addedPartial = true;
                    }
                    statuses.push({
                        id: status.get('id'),
                        name: status.get('name'),
                        style: 'color: ' + PJQ.constants.submittals.statusTypeColors[status.get('type')]
                    });
                });

                let stChoices;
                if (this.options.settings.get('enableWorkflow')) {
                    statuses.push({
                        id: '-1',
                        name: 'Closed',
                        style: 'color: ' + PJQ.constants.colors.RED
                    });
                    stChoices = statuses;
                } else {
                    stChoices = [
                        {
                            name: 'Status',
                            choices: statuses
                        },
                        {
                            name: '',
                            choices: [
                                {
                                    id: '0',
                                    name: 'As Noted'
                                }
                            ]
                        }
                    ];
                }

                new PJQ.inputs.Selectpicker({
                    el: $header.find('.submittal-filter'),
                    onChange: function (value) {
                        view.setFilter('statusId', value);
                    },
                    choices: stChoices,
                    isIntChoices: true,
                    isMultiple: true,
                    noneSelectedText: 'No Filters'
                });
            },
            getFilterData: function (view, data) {
                let statusFilter = view.getFilter('statusId');
                if (_.size(statusFilter) === 0) {
                    return data;
                }

                let showPartial = _.contains(statusFilter, -1),
                    showAsNoted = _.contains(statusFilter, 0);

                // we only want the status filter to have actual statuses in it now
                statusFilter = _.filter(statusFilter, (statusId) => {
                    return statusId > 0;
                });
                return _.filter(data, function (row) {
                    let statusMatch = (statusFilter.length > 0 && _.contains(statusFilter, row.get('statusId')) && !row.get('isClosed'))
                        || (showPartial && row.isPartiallyApproved())
                        || (showPartial && row.get('isClosed'));
                    return statusMatch && (!showAsNoted || row.get('asNotedCommentId') > 0);
                });
            },
            onRowDoubleClick: _.bind(function (row) {
                this.editSubmittal(row.data());
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: _.bind(function (row) {
                            this.editSubmittal(row.data());
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: _.bind(function (row) {
                            this.deleteSubmittal(row);
                        }, this)

                    }
                ]
            },
            columns: this.getColumns(false),
            colReorder: {
                fixedColumnsLeft: 0,
                fixedColumnsRight: 1,
                realtime: false
            },
            columnOrderChanged: _.bind(function () {
                if (this.options.userSettings != null) {
                    this.options.userSettings.save();
                }
            }, this)
        });

    },
    getColumns: function (includeAllColumns = false) {
        let columns = [], includeColumns = [],
            viewSettings = this.options.userSettings.getSettings(PJQ.constants.submittals.view.SUBMITTALS);

        if (includeAllColumns) {
            includeColumns = ["submittalNumber", "title", "itemTypes", "dueDate", "groupList", "submitter", "ballInCourt", "approverList", "distributionList", "status"];

            if (_.size(this.options.customFields) > 0) {
                _.each(this.options.customFields.models, function (customField) {
                    includeColumns.push('fieldValue' + customField.get('fieldNumber'));
                });
            }
        } else
            includeColumns = viewSettings.columns;

        _.each(includeColumns, _.bind(function (column) {
            if (this.preferences.getPref(PJQ.constants.preferenceTypes.HIDE_SUBMITTAL_ITEM_TYPE) && column === 'itemTypes') {
                return;
            }
            switch (column) {
                case 'submittalNumber':
                    columns.push({
                        "data": "attributes.submittalNumber",
                        "columnData": "submittalNumber",
                        "title": "Number",
                        "render": (data, type, row) => {
                            if (type === 'sort' || type === 'type') {
                                return data;
                            }

                            return '<a href="javascript:void(0)" class="btn-edit-submittal">' + data + '</a>';
                        },
                        'visible': viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'title':
                    columns.push({
                        "columnData": "title",
                        "title": "Title",
                        "data": "attributes.title",
                        'visible': viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'itemTypes':
                    columns.push({
                        "columnData": "itemTypes",
                        "title": "Item Types",
                        "data": "itemTypes",
                        "render": function (data, type, row) {
                            if (_.size(row.itemTypes.models) > 0) {
                                let itemTypeNames = [];
                                _.each(row.itemTypes.models, function (itemType) {
                                    itemTypeNames.push(itemType.get('name'));
                                });
                                return itemTypeNames.join(", ");
                            }
                            return '';
                        },
                        'visible': viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'dueDate':
                    columns.push({
                        "columnData": "dueDate",
                        "title": "Due Date",
                        "data": "attributes.dueDate",
                        "render": (data, type, row) => {
                            if (data != null) {
                                let dueDate = new Date(data),
                                    dateString = PJQ.helpers.dateHelpers.getDateString(dueDate, PJQ.helpers.dateHelpers.dateFormats.DATE);
                                if (row.isNewStatus(this.options.statuses) && PJQ.helpers.dateHelpers.getDateDaysDiff(dueDate, new Date()) < 0) {
                                    return '<span class="text-danger font-weight-bold">' + dateString + '</span>';
                                }
                                return dateString;
                            }
                            return 'Not Set';
                        },
                        'visible': viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'groupList':
                    columns.push({
                        "columnData": "groupList",
                        "title": this.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LABEL) ?? "Trades",
                        "data": "groups",
                        "render": function (data, type, row) {
                            if (_.size(row.groups.models) > 0) {
                                let groupNames = [];
                                _.each(row.groups.models, function (group) {
                                    groupNames.push(group.get('groupName'));
                                });
                                return groupNames.join(", ");
                            }
                            return '';
                        },
                        'visible': viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'submitter':
                    columns.push({
                        "columnData": "submitter",
                        "title": "Submitter",
                        "data": "submitter",
                        render: function (data, type, row) {
                            let result = '';
                            if (row.submitter != null) {
                                return PJQ.helpers.contacts.getContactAnchor({contact: row.submitter});
                            } else {
                                result = 'Nobody';
                            }
                            return result;
                        },
                        'visible': viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'ballInCourt':
                    columns.push({
                        "columnData": "ballInCourt",
                        "title": "Ball In Court",
                        "data": "ballInCourt",
                        render: (data, type, row) => {
                            let result = [],
                                enableWorkflow = this.options.settings.get('enableWorkflow'),
                                currentStep = row.workflow?.getCurrentStep();
                            if (row.ballInCourt != null && !row.isVoidStatus(this.options.statuses)) {
                                result.push(PJQ.helpers.contacts.getContactAnchor({contact: row.ballInCourt}));
                            } else if (!enableWorkflow && row.isSubmittedStatus(this.options.statuses) || row.isPartiallyApproved()) {
                                result.push(this.options.settings.getApproveStatusName('ers'));
                            } else if (!row.get('isClosed') && enableWorkflow && row.isSubmittedStatus(this.options.statuses)) {
                                if (currentStep != null) {
                                    _.each(currentStep.approvers.models, (approver) => {
                                        let person = approver.get('person');
                                        if (person == null) {
                                            return;
                                        }
                                        result.push(PJQ.helpers.contacts.getContactAnchor({contact: person}));
                                    });
                                } else if (_.size(row.get('ballInCourtApproverList')) > 0) {
                                    _.each(row.get('ballInCourtApproverList'), function (contact) {
                                        result.push(PJQ.helpers.contacts.getContactAnchor({contact: contact}));
                                    });
                                } else {
                                    result.push(this.options.settings.getApproveStatusName('ers'));
                                }
                            } else {
                                result.push('Nobody');
                            }
                            return result.join(', ');
                        },
                        'visible': viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'approverList':
                    columns.push({
                        columnData: 'approverList',
                        title: "Approver List",
                        render: function (data, type, row) {
                            let result = [];
                            if (_.size(row.get('approvers')) > 0) {
                                _.each(row.get('approvers'), function (contact) {
                                    result.push(PJQ.helpers.contacts.getContactAnchor({contact: contact}));
                                });
                            } else if(row.workflow != null){
                                let approvers = row.workflow.getAllApprovers();
                                _.each(approvers, function (contact) {
                                    result.push(PJQ.helpers.contacts.getContactAnchor({contact: contact.get('person')}));
                                });
                            } else {
                                result.push('Nobody');
                            }
                            return result.join(', ');
                        },
                        visible: viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'distributionList':
                    columns.push({
                        columnData: 'distributionList',
                        title: "Distribution List",
                        render: function (data, type, row) {
                            let result = [];
                            if (_.size(row.distributionList.models) > 0) {
                                _.each(row.distributionList.models, function (contact) {
                                    result.push(PJQ.helpers.contacts.getContactAnchor({contact: contact}));
                                });
                            } else {
                                result.push('Nobody');
                            }
                            return result.join(', ');
                        },
                        visible: viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'status':
                    columns.push({
                        "columnData": "status",
                        "title": "Status",
                        "data": "attributes.statusId",
                        "render": _.bind(function (data, type, row) {
                            return '<span style="color:' + row.getStatusColor(this.options.statuses) + '">' + row.getStatusName(this.options.settings, this.options.statuses) + '</span>';
                        }, this),
                        'visible': viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                default:
                    if (column.startsWith('fieldValue')) {
                        _.each(this.options.customFields.models, function (customField) {
                            if (column === 'fieldValue' + customField.get('fieldNumber')) {
                                columns.push({
                                    "columnData": 'fieldValue' + customField.get('fieldNumber'),
                                    "title": customField.get('fieldName'),
                                    "className": [PJQ.constants.commitments.customFieldType.INTEGER, PJQ.constants.commitments.customFieldType.MONEY, PJQ.constants.commitments.customFieldType.PERCENT].indexOf(customField.get('fieldTypeId')) !== -1 ? "text-align-right" : "",
                                    'visible': viewSettings.columns.indexOf(column) !== -1,
                                    "render": function (data, type, row) {
                                        let fieldValue = row.getCustomFieldValue(customField.get('id'));
                                        fieldValue = (fieldValue !== null) ? fieldValue : '';
                                        switch (customField.get('fieldType')) {
                                            case 'BOOL':
                                                if (fieldValue != null)
                                                    fieldValue = fieldValue ? 'Yes' : 'No';
                                                break;
                                            case 'CHOICE':
                                                let choices = [];
                                                // convert single choice value into array so that the logic below can work for both types.
                                                if (typeof fieldValue === 'number')
                                                    fieldValue = [fieldValue];

                                                _.each(customField.choices.models, _.bind(function (choice) {
                                                    if (_.find(fieldValue, function (value) {
                                                        return value === choice.get('id');
                                                    }))
                                                        choices.push(choice.get('choiceName'));
                                                }, this));

                                                fieldValue = choices.join((', '));
                                                break;
                                            case 'DATE':
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case 'DATETIME':
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, false);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case 'INT':
                                                if (type !== 'sort' && type !== 'type' && fieldValue) {
                                                    fieldValue = parseInt(fieldValue).toLocaleString();
                                                }
                                                break;
                                            case 'MONEY':
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)));
                                                }
                                                break;
                                            case 'PERCENT':
                                                if (type === 'sort' || type === 'type') {
                                                    if (!fieldValue)
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = fieldValue ? PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)), 2, false) + '%' : '';
                                                }
                                                break;
                                        }

                                        return fieldValue;
                                    }
                                });
                            }
                        });
                    }
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "data": "",
                "title": "",
                "orderable": false,
                "searchable": false,
                resizable: false,
                "width": '100px',
                "render": _.bind(function () {
                    let html = '<div class="show-on-row-hover" style="min-width:80px;"><button type="button" class="btn btn-info btn-edit-submittal"><i class="fal fa-pencil"></i></button>';
                    if (this.options.isAdmin) {
                        html += '<button type="button" class="btn btn-danger btn-delete-submittal ml-1"><i class="fal fa-trash"></i></button>';
                    }
                    html += '</div>';
                    return html;
                }, this)
            });
        }

        return columns;
    },
    addClicked: function () {
        this.editSubmittal(null);
    },
    editClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr')),
            submittal = row.data();
        this.editSubmittal(submittal);
    },
    editSubmittal: function (submittal) {
        new PJQ.views.submittals.EditSubmittalModal({
            model: submittal,
            templateId: this.model ? this.model.get('templateId') : null,
            project: this.options.project,
            onSave: (model, isNew) => {
                if (isNew) {
                    this.collection.add(model);
                    this.dataTable.addRow(model);
                }
                this.dataTable.refresh();
            },
            onClose: () => {
                this.dataTable.refresh();
            },
            onDelete: (submittal) => {
                let row = this.dataTable.getRow(submittal.cid);
                if (row != null) {
                    this.dataTable.removeRow(row);
                }
                submittal.destroy();
            }
        }, this)
    },
    deleteClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.deleteSubmittal(row);
    },
    deleteSubmittal: function (row) {
        let submittal = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this Submittal?",
            onDelete: _.bind(function () {
                submittal.destroy();
                this.dataTable.removeRow(row);
            }, this)
        });
    },
    editSettings: function () {
        new PJQ.views.submittals.SettingsModal({
            submittalsView: this,
            model: this.options.settings,
            userSettings: this.options.userSettings,
            project: this.options.project ? this.options.project : null,
            onSave: _.bind(function () {
                this.renderDataTable();
            }, this)
        });
    },
    saveTemplate: function () {
        new PJQ.views.submittals.SubmittalTemplateCreatorModal({
            collection: this.collection,
            project: this.options.project
        });
    },
    importTemplate: function () {
        new PJQ.views.submittals.ImportTemplateModal({
            project: this.options.project,
            onImport: _.bind(function (submittals) {
                this.collection = submittals;
                this.render();
            }, this)
        });
    },
    exportSubmittals: function () {
        new PJQ.ajax.Request({
            endpoint: this.options.project.endpoint() + '/submittals/export',
            data: {
                isApi2: true
            }
        }).post().done(_.bind(function (response) {
            PJQ.files.downloadFile(response.url, {
                isEndpoint: false
            });
        }, this)).fail(_.bind(function (xhr, err, result) {
        }, this));
    },
    exportList: function (e) {
        if (this.options.project == null) {
            return;
        }

        let $target = $(e.currentTarget),
            type = $target.data('type'),
            orderCookie = PJQ.helpers.cookieHelpers.getCookie(PJQ.constants.cookies.SUBMITTAL_ORDER_COOKIE),
            order = orderCookie != null ? JSON.parse(orderCookie) : null,
            report = new PJQ.models.reports.NewReport({
                type: PJQ.constants.reports.reportTypes.SUBMITTAL.type,
                projectId: this.options.project ? this.options.project.id : null,
                options: {
                    columns: this.options.userSettings.getSettings(PJQ.constants.submittals.view.SUBMITTALS).columns,
                    columnOrder: order
                }
            });
        report.export({format: type}).then(() => {

        });
    },
});

PJQ.views.submittals.EditHistoryModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'edit-history-modal'),
        subTemplates: {
            history: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'edit-history'),
        },
        width: '50%',
        maxWidth: 700,
        onSave: _.noop
    },
    events: {},
    afterRender: function () {
        this.renderHistory()
    },
    renderHistory: function () {
        this.renderSubTemplate(false, this.options.subTemplates.history, this.$('.history-outer'), {
            history: this.options.history.models.reverse()
        });
    }
});

PJQ.views.submittals.FileEditorModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'modal-file-editor'),
        isNewVersion: false,
        isNoteEdit: false
    },
    events: {
        'click .btn-save': 'save'
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model,
            isNoteEdit: this.options.isNoteEdit,
            isNewVersion: this.options.isNewVersion
        };
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'textarea'
            ]
        });
        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.submittal-file-uploader'),
            collection: this.collection,
            style: 'list',
            canUpload: (this.collection.models.length === 0 || !this.options.isNewVersion),
            canDelete: true,
            canDownload: true,
            isRemoveOnComplete: this.options.isNewVersion,
            previewImageDimension: 150,
            onSuccess: _.bind(function () {
                if (this.options.isNewVersion) {
                    this.render();
                }
            }, this),
            onDelete: _.bind(function (attachment, callback) {
                if (attachment.id > 0) {
                    attachment.set('isDeleted', true);
                } else {
                    attachment.destroy();
                }
                this.model.isDirty = true;
                callback();
            }, this)
        });
    },
    save: function () {
        if (this.options.isNewVersion) {
            this.collection.add(this.model);
        }

        this.options.onSave(this.collection);
        this.removeModal();
    }
});

PJQ.views.submittals.StatusChangeCommentModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'modal-status-change-comment'),
        title: null
    },
    events: {
        'click .btn-save': 'save'
    },
    renderData: function () {
        return {
            model: this.model,
            title: this.options.title
        }
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'textarea'
            ]
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.input-due-date'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('dueDate') ? new Date(this.model.get('dueDate')) : null
            },
            onChange: _.bind(function (newDate) {
                this.model.set('dueDate', newDate);
            }, this)
        });
    },
    save: function () {
        let val = this.$('.item-status-change-comment').val().trim();
        if (_.size(val) === 0) {
            this.options.onSave(this.model, null);
            this.removeModal();
        } else {
            let comment = new PJQ.models.submittals.Comment({
                submittalId: this.model.id,
                comment: val,
                createdOn: new Date(),
                asNoted: true
            });
            this.model.comments.add(comment);
            this.options.onSave(this.model, comment);
            this.removeModal();
        }
    }
});

PJQ.views.submittals.SubmittalTemplateCreatorModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'modal-create-template'),
        width: '30%'
    },
    events: {
        'click .btn-save' : 'save'
    },
    beforeModalCreated: function () {
        this.model = new PJQ.models.submittals.Template({
            projectId: this.options.project.id
        });

        this.options.project.fetchSubmittalTemplates(_.bind(function (tmp) {
            this.templates = tmp;
            this.render();
        }, this));
    },
    renderData: function () {
        return {
            templates: this.templates,
            submittals: this.collection
        };
    },
    afterRender: function () {
        if (this.templates != null && this.templates.isFetched) {
            new PJQ.inputs.Selectpicker({
                el: this.$('.select-submittal'),
                isMultiple: true,
                noneSelectedText: 'Select Submittal #',
                onChange: _.bind(function (value) {

                }, this)
            });

            new PJQ.inputs.AutocompleteInput({
                el: this.$('.input-template-name'),
                source: _.map(this.templates.models, function (template) {
                    return template.get('name')
                })
            });
        }
    },
    save: function () {
        let $name = this.$('.input-template-name'),
            name = $name.val();
        if (_.size(name.trim()) === 0) {
            PJQ.helpers.inputHelpers.setInputError($name);
            return;
        }
        else {
            PJQ.helpers.inputHelpers.setInputError($name, true);
        }

        let existingTemplate = this.templates.findWhere({name: name}),
            fnSave = _.bind(function () {
                this.model.set({
                    name: name,
                    copyComments: this.$('.input-copy-comments').prop('checked'),
                    copySubmitter: this.$('.input-copy-submitter').prop('checked'),
                    copyApprovers: this.$('.input-copy-approvers').prop('checked'),
                    copyGroups: this.$('.input-copy-trades').prop('checked'),
                    copyDistribution: this.$('.input-copy-distribution').prop('checked'),
                    copyItemTypes: this.$('.input-copy-item-types').prop('checked')
                });
                this.model.save(null, {
                    success: _.bind(function () {
                        this.removeModal();
                        PJQ.notifications.notify.successNotify({
                            message: 'Submittal Template Created'
                        });
                    }, this)
                });
            }, this);
        if (existingTemplate != null) {
            new PJQ.views.modals.YesNo({
                header: "Overwrite Template",
                body: "A template already exists with this name.  Would you like to overwrite it?",
                onYes: _.bind(function () {
                    this.model.set('templateId', existingTemplate.id);
                    fnSave();
                }, this)
            });
        }
        else {
            fnSave();
        }
    }
});

PJQ.views.submittals.ImportTemplateModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'modal-import-template'),
        maxWidth: 500,
        onImport: null
    },
    events: {
        'click .btn-import': 'save'
    },
    beforeModalCreated: function () {
        this.options.project.fetchSubmittalTemplates(_.bind(function (tmp) {
            this.templates = tmp;
            this.render();
        }, this));
    },
    renderData: function () {
        return {
            templates: this.templates
        };
    },
    afterRender: function () {
        if (this.templates != null && this.templates.isFetched) {
            this.templatePicker = new PJQ.inputs.Selectpicker({
                el: this.$('.select-template'),
                onChange: _.bind(function (value) {
                    this.selectedTemplate = this.templates.get(value);
                }, this),
                isIntChoices: true,
                noneSelectedText: 'Select Template'
            });

        }
    },
    save: function () {
        let isValid = true;
        if (this.selectedTemplate == null) {
            this.templatePicker.showError();
            isValid = false;
        }
        else {
            this.templatePicker.hideError();
        }


        if (!isValid) {
            return;
        }

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'submittals'
                },
                {
                    endpoint: 'import',
                    value: this.selectedTemplate.id
                }
            ], [
                {
                    parameter: 'importComments',
                    value: this.$('.input-import-comments').prop('checked')
                },
                {
                    parameter: 'importSubmitter',
                    value: this.$('.input-import-submitter').prop('checked')
                },
                {
                    parameter: 'importApprovers',
                    value: this.$('.input-import-approvers').prop('checked')
                },
                {
                    parameter: 'importGroups',
                    value: this.$('.input-import-trades').prop('checked')
                },
                {
                    parameter: 'importDistribution',
                    value: this.$('.input-import-distribution').prop('checked')
                },
                {
                    parameter: 'importItemTypes',
                    value: this.$('.input-import-item-types').prop('checked')
                },
            ])
        }).put().done(_.bind(function (response) {
            if (typeof this.options.onImport === 'function') {
                let result = new PJQ.collections.submittals.Submittals(response);
                result.isFetched = true;
                this.options.onImport(result);
            }
            this.removeModal();
            PJQ.notifications.notify.successNotify({
                message: 'Submittal Template Imported'
            });
        }, this));
    }
});

PJQ.views.submittals.EditTemplateModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'Modal-Edit-Template'),
        maxWidth: '90%',
        fitHeight: true,
        onClose: null
    },
    events: {
        'click .btn-close': 'close',
        'click .btn-delete': 'deleteTemplate'
    },
    beforeModalCreated: function () {
        this.listenTo(this.model, 'fetch', this.render);
        this.model.fetch();
    },
    renderData: function () {
        return {
            model: this.model
        };
    },
    afterRender: function () {
        if (this.model.isFetched) {

            new PJQ.inputs.TextEditorInput({
                el: this.$('.edit-template-name'),
                label: 'Name',
                value: this.model.get('name'),
                onSave: _.bind(function (value) {
                    this.model.patch({
                        name: value
                    });
                }, this)
            });

            new PJQ.views.submittals.SubmittalsView({
                el: this.$('.manage-template'),
                model: this.model,
                collection: this.model.submittals
            });
        }
    },
    close: function () {
        if (typeof this.options.onClose === 'function') {
            this.options.onClose(this.model);
        }
    },
    deleteTemplate: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this template?",
            onDelete: _.bind(function () {
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(this.model);
                }
                this.removeModal();
            }, this)
        });
    }
});


PJQ.views.submittals.TemplateManagement = PJQ.views.templates.TemplateManagement.extend({
    beforeFirstRender: function () {
        this.collection = new PJQ.collections.submittals.Templates();
        this.listenTo(this.collection, 'fetch', this.render);
        this.collection.fetch();
    },
    addTemplate: function () {
        new PJQ.views.templates.NewTemplateModal({
            model: new PJQ.models.submittals.Template(),
            onSave: _.bind(function (template) {
                this.collection.add(template);
                this.editTemplate(template);
            }, this)
        });
    },
    editTemplate: function (template) {
        new PJQ.views.submittals.EditTemplateModal({
            model: template,
            onClose: _.bind(function () {
                this.dataTable.refresh();
            }, this),
            onDelete: _.bind(function (template) {
                if (template.id > 0) {
                    let row = this.dataTable.getRow(template.cid);
                    this.collection.remove(template);
                    template.destroy();
                    this.dataTable.removeRow(row);
                }
            }, this)
        });
    }
});

PJQ.views.submittals.WorkflowView = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'submittal-workflow'),
        onChange: null,
        canEdit: true,
        canChangeBallInCourt: false,
        canRespond: true,
        onRespond: null,
        onSetBallInCourt: null
    },
    events: {
        'click .btn-edit-workflow': 'editWorkflow',
        'change .cb-required': 'approverRequiredChanged',
        'change .cb-reject-to-manager': 'returnOnRejectChanged',
        'keyup .input-days-to-respond': 'daysToRespondChanged',
        'click .btn-add-approver': 'addApprover',
        'click .btn-delete-approver': 'deleteApprover',
        'click .btn-add-step': 'addStep',
        'click .btn-apply-template': 'applyTemplateClicked',
        'click .btn-delete-step': 'deleteStepClicked',
        'click .btn-respond': 'respondToSubmittal',
        'click .btn-update-response': 'respondToSubmittal',
        'click .btn-set-bic': 'setBallInCourt',
        'click .dl-approver-attachment': 'downloadApproverAttachment'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        this.options.userSettings = await PJQ.app.session.fetchSubmittalUserSettings();
        if (this.options.project != null) {
            this.options.settings = await this.options.project.fetchSubmittalSettings();
            this.options.statuses = await this.options.project.fetchSubmittalStatuses();
        } else {
            this.options.settings = await PJQ.app.session.fetchSubmittalSettings();
            this.options.statuses = await PJQ.app.session.fetchSubmittalStatuses();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: async function () {
        this.options.canAdd = this.options.project ? this.options.project.hasPermission('submittals.canAdd') : PJQ.app.session.hasPermission('settings.canManageSubmittals');
        this.options.isAdmin = this.options.project ? this.options.project.hasPermission('submittals.isAdmin') : PJQ.app.session.hasPermission('settings.canManageSubmittals');

        if (this.isFetched && this.options.isEdit && this.workflowTemplates == null) {
            this.isFetched = false;
            this.workflowTemplates = await this.options.project.fetchSubmittalWorkflowTemplates();
            this.isFetched = true;
            this.render();
        }
    },
    renderData: function () {
        return {
            canEdit: this.options.canEdit,
            isEdit: this.options.isEdit === true,
            project: this.options.project,
            submittal: this.options.submittal,
            workflow: this.model,
            workflowTemplates: this.workflowTemplates,
            isFetched: this.isFetched
        };
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.renderStepsTable();
    },
    setEdit: function (edit) {
        this.options.isEdit = edit;
        this.render();
    },
    editWorkflow: function () {
        this.setEdit(true);
    },
    approverRequiredChanged: function (e) {
        let $target = $(e.currentTarget),
            $badge = $target.closest('.badge-approver'),
            cid = $badge.data('cid'),
            stepCid = $badge.data('stepCid');

        let step = this.model.steps.get(stepCid);
        if (step == null) {
            return;
        }

        let approver = step.approvers.get(cid);
        if (approver == null) {
            return;
        }

        approver.set('isRequired', $target.prop('checked'));
        this.onChange(step);
    },
    returnOnRejectChanged: function (e) {
        let $target = $(e.currentTarget),
            $tr = $target.closest('tr'),
            row = this.stepsDatatable.getRow($tr),
            step = row.data();
        if (step == null) {
            return;
        }

        step.set('returnOnReject', $target.prop('checked'));
        this.onChange(step);
    },
    daysToRespondChanged: function (e) {
        let $target = $(e.currentTarget),
            $tr = $target.closest('tr'),
            row = this.stepsDatatable.getRow($tr),
            step = row.data();
        if (step == null) {
            return;
        }

        step.set('daysToRespond', parseInt($target.val()));
        this.onChange(step);
    },
    respondToSubmittal: function (e) {
        let $tr = $(e.currentTarget).closest('tr'),
            row = this.stepsDatatable.getRow($tr),
            approver = row.data();
        new PJQ.views.submittals.WorkflowResponseModal({
            project: this.options.project,
            submittal: this.options.submittal,
            approver: approver,
            onSave: () => {
                if (typeof this.options.onRespond === 'function') {
                    this.options.onRespond(approver);
                }
            }
        });
    },
    setBallInCourt: function (e) {
        let $btn = $(e.currentTarget),
            stepCid = $btn.data('stepCid'),
            step = this.model.steps.get(stepCid);
        if (step == null) {
            return;
        }

        new PJQ.views.modals.YesNo({
            header: "Set Ball In Court?",
            body: "Are you sure you want to set this workflow step to the ball in court? This will reset all responses on the selected step.",
            onYes: () => {
                this.options.submittal.setBallInCourt(step.id, (success) => {
                    if (success) {
                        this.renderStepsTable();

                        if (typeof this.options.onSetBallInCourt === 'function') {
                            this.options.onSetBallInCourt(step);
                        }

                        PJQ.notifications.notify.successNotify({
                            message: 'Ball in court changed successfully'
                        });
                    }
                });
            }
        });
    },
    downloadApproverAttachment: function (e) {
        let cid = $(e.currentTarget).data('cid'),
            attachment = this.options.submittal.attachments.get(cid);
        if (attachment == null) {
            return;
        }

        attachment.download();
    },
    addApprover: function (e) {
        let $tr = $(e.currentTarget).closest('tr'),
            row = this.stepsDatatable.getRow($tr),
            step = row.data(),
            approvers = _.map(_.filter(step.approvers.models, (approver) => {
                return !approver.get('delete');
            }), (approver) => {
                return {
                    id: approver.get('person').id
                };
            });
        this.selector = new PJQ.views.contacts.SelectContactsModal({
            contacts: this.options.contacts,
            hideContacts: approvers,
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            isSingleChoice: false,
            // saveButtonText: this.options.saveButtonText,
            onSave: (newContacts) => {
                _.each(newContacts, (contact) => {
                    step.approvers.add(new PJQ.models.submittals.WorkflowApprover({
                        personId: contact.id,
                        isRequired: true,
                        person: contact.toJSON()
                    }));
                });
                this.renderStepsTable();
                this.onChange(step);
            }
        });
    },
    deleteApprover: function (e) {
        let $badge = $(e.currentTarget).closest('.badge-approver'),
            cid = $badge.data('cid'),
            stepCid = $badge.data('stepCid');

        let step = this.model.steps.get(stepCid);
        if (step == null) {
            return;
        }

        let approver = step.approvers.get(cid);
        if (approver == null) {
            return;
        }

        if (approver.id > 0) {
            approver.set('delete', true);
        } else {
            step.approvers.remove(approver);
        }

        this.renderStepsTable();
        this.onChange(step);
    },
    applyTemplateClicked: function (e) {
        let $btn = $(e.currentTarget),
            templateId = $btn.data('id'),
            template = this.workflowTemplates.get(templateId);

        if (_.find(this.model.steps.models, (step) => {
            return !step.get('delete')
        })) {
            new PJQ.views.modals.YesNo({
                header: "Apply Workflow Template?",
                body: "Are you sure you want to apply this workflow template? All current steps will be removed.",
                onYes: () => {
                    this.applyTemplate(template);
                }
            });
        } else {
            this.applyTemplate(template);
        }
    },
    applyTemplate: function (template) {
        let fnApplyTemplate = () => {
            let cWorkflow = template.workflow.clone();
            _.each(this.model.steps.models, (step) => {
                if (step.id > 0) {
                    step.set('delete', true);
                } else {
                    step.destroy();
                }
            });
            this.model.steps.add(cWorkflow.steps.models);
            this.renderStepsTable();

            this.onChange();
        };
        if (template.isFetched) {
            fnApplyTemplate();
        } else {
            template.fetch({
                success: () => {
                    fnApplyTemplate();
                },
                error: () => {
                    PJQ.notifications.notify.errorNotify({
                        message: 'Failed to fetch template'
                    });
                }
            })
        }
    },
    addStep: function () {
        let step = new PJQ.models.submittals.WorkflowStep({
            number: _.filter(this.model.steps.models, (step) => {
                return !step.get('delete')
            }).length + 1,
            approvers: []
        });
        this.model.steps.add(step);
        this.renderStepsTable();
        this.onChange(step);
    },
    deleteStepClicked: function (e) {
        let $tr = $(e.currentTarget).closest('tr'),
            row = this.stepsDatatable.getRow($tr),
            step = row.data();
        this.deleteStep(step);
    },
    deleteStep: function (step) {
        if (step == null) {
            return;
        }

        if (step.id > 0) {
            step.set('delete', true);
        } else {
            this.model.steps.remove(step);
        }

        _.each(_.sortBy(_.filter(this.model.steps.models, (step) => {
            return !step.get('delete')
        }), (step) => {
            return step.id;
        }), (step, index) => {
            step.set('number', index + 1);
        });

        this.renderStepsTable();
        this.onChange(step);
    },
    onChange: function (step) {
        this.model.isDirty = true;
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(step);
        }
    },
    renderStepsTable: function () {
        let columns,
            data,
            approveLabel = this.options.settings.getApproveStatusName('ers');
        if (this.options.isEdit) {
            data = _.filter(this.model.steps.models, (step) => {
                return !step.get('delete');
            });
            columns = [
                {
                    "data": "attributes.number",
                    "title": "",
                    "width": "20px",
                    "orderable": false,
                    "searchable": false
                },
                {
                    "title": _.size(approveLabel) > 0 ? approveLabel : "Approvers",
                    "data": "approvers",
                    "orderable": false,
                    "render": _.bind(function (data, type, row) {
                        let result = '',
                            approvers = row.approvers ? _.filter(row.approvers.models, (approver) => {
                                return !approver.get('delete')
                            }) : [];
                        if (_.size(approvers) === 0) {
                            result = 'Nobody';
                        } else {
                            let fnMakeCheckmark = (isRequired) => {
                                return '<div class="pretty p-default p-smooth ml-1"><input type="checkbox" class="cb-required" ' + (isRequired ? 'checked' : '') + ' /><div class="state p-primary"><label class="fs-15 division-expand noselect">&nbsp;</label></div></div>';
                            };
                            _.each(approvers, (approver) => {
                                result += '<div data-step-cid="' + row.cid + '" data-cid="' + approver.cid + '" class="badge-approver badge badge-light text-dark p-1 m-1 fs-14">' + fnMakeCheckmark(approver.get('isRequired')) + approver.get('person').contactName + '<button type="button" class="btn btn-sm btn-transparent-dark btn-delete-approver text-dark ml-1 fs-12"><span class="fal fa-times text-dark"></span></button></div>'
                            });
                        }

                        return '<div>' + result + '<button type="button" class="btn btn-sm btn-transparent-dark btn-add-approver text-primary ml-1 mr-1 fs-15"><span class="fal fa-plus"></span></button></div>';
                    }, this)
                },
                {
                    "data": "attributes.returnOnReject",
                    "title": 'Reject to Manager',
                    "width": "100px",
                    "orderable": false,
                    "render": _.bind(function (data, type, row) {
                        return '<div class="text-align-center"><div class="pretty p-default p-smooth"><input type="checkbox" class="cb-reject-to-manager" ' + (data ? 'checked' : '') + ' /><div class="state p-primary"><label class="fs-15">&nbsp;</label></div></div></div>';
                    }, this)
                },
                {
                    "data": "attributes.daysToRespond",
                    "title": 'Days to Respond',
                    "width": "100px",
                    "orderable": false,
                    "render": _.bind(function (data, type, row) {
                        return '<input type="number" class="form-control input-days-to-respond" value="' + (data ?? 0) + '">';
                    }, this)
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "40px",
                    "render": _.bind(function (data, type, row) {
                        let html = '<div class="text-align-right show-on-row-hover">'
                        html += '<button type="button" class="btn btn-danger btn-delete-step ht-30p wd-35p ml-1 fs-14"><span class="fal fa-trash"></span></button>'
                        return html + '</div>';
                    }, this)
                }];
        } else {
            data = [];
            _.each(this.model.steps.models, (step) => {
                let approvers = step.approvers.models;
                _.each(approvers, (approver) => {
                    approver.step = step;
                });
                data.push(...approvers);
            });
            columns = [
                {
                    "data": "step.attributes.number",
                    "columnData": "step.attributes.number",
                    "title": "",
                    "width": "20px",
                    "orderable": false,
                    "searchable": false,
                    "visible": false,
                    group: (row) => {
                        return row.step.cid;
                    }
                },
                {
                    "data": "attributes.id",
                    "title": "",
                    "width": "20px",
                    "orderable": false,
                    "searchable": false,
                    render: (data, type, row) => {
                        // show icon if this is the current user
                        return '';
                    }
                },
                {
                    "data": "attributes.person",
                    "title": "Name",
                    "width": "200px",
                    "orderable": false,
                    "searchable": false,
                    "render": (data, type, row) => {
                        let personAnchor = PJQ.helpers.contacts.getContactAnchor({contact: row.get('person')}),
                            req = '';
                        if (row.get('isRequired'))
                            req = '<i class="fal fa-asterisk mr-2"></i>';
                        return '<div class="d-flex align-items-center"><div style="width:30px">' + req + '</div><div><div class="font-weight-bold">' + row.get('person').companyName + '</div><div>' + personAnchor + '</div></div></div>';
                    }
                },
                {
                    "data": "attributes.ballInCourtOn",
                    "title": 'Sent',
                    "render": (data, type, row) => {
                        if (data == null) {
                            return '';
                        }

                        return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                    }
                },
                {
                    "data": "attributes.dueOn",
                    "title": 'Due',
                    "width": '90px',
                    "render": (data, type, row) => {
                        if (data == null) {
                            return '';
                        }

                        return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                    }
                },
                {
                    "data": "attributes.responseOn",
                    "title": "Responded",
                    "width": "100px",
                    "render": (data, type, row) => {
                        if (data == null) {
                            return '';
                        }

                        return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                    }
                },
                {
                    "data": "attributes.statusId",
                    "title": "Response",
                    "width": "120px",
                    "render": (data, type, row) => {
                        if (data > 0) {
                            let status = this.options.statuses.get(data);
                            if (status == null) {
                                return '';
                            }

                            let sColor = PJQ.constants.submittals.statusTypeColors[status.get('color')];
                            return '<span style="color:' + sColor + '">' + status.get('name') + '</span>';
                        } else if (!this.options.canRespond || !row.step.get('isActive') || !row.get('isMe')) {
                            return '';
                        }
                        return '<div class="text-align-center"><button type="button" class="btn btn-light btn-respond">Respond</button></div>';
                    }
                },
                {
                    "data": "attributes.responseText",
                    "title": "Comments",
                    "orderable": false,
                    "render": (data, type, row) => {
                        return row.get('responseText') ?? '';
                    }
                },
                {
                    "data": "attachments",
                    "title": "Attachments",
                    "orderable": false,
                    "render": (data, type, row) => {
                        if (this.options.submittal == null || this.options.submittal.attachments == null) {
                            return '';
                        }

                        let approverAttachments = [];
                        _.each(this.options.submittal.attachments.models, (attachment) => {
                            if (attachment.get('approverId') === row.id) {
                                approverAttachments.push({
                                    cid: attachment.cid,
                                    name: attachment.get('name'),
                                    newest: _.size(attachment.versions?.models) === 0
                                });
                            }

                            if (attachment.versions != null && attachment.versions.models.length > 0) {
                                let newestVer = _.max(attachment.versions.models, (ver) => {
                                    return ver.get('version');
                                }).get('version');
                                _.each(attachment.versions.models, (ver) => {
                                    if (ver.get('approverId') !== row.id) {
                                        return;
                                    }

                                    approverAttachments.push({
                                        cid: ver.cid,
                                        name: ver.get('name'),
                                        newest: newestVer === ver.get('version')
                                    });
                                })
                            }
                        });
                        if (approverAttachments.length === 0) {
                            return '';
                        }

                        let result = '';
                        _.each(approverAttachments, (attachment) => {
                            result += '<a href="javascript:void(0)" class="btn-dl-approver-attachment ' + (attachment.newest ? '' : 'text-dec-line-through') + '" data-cid="' + attachment.cid + '">' + attachment.name + '</a><br>';
                        });
                        return '<div class="fs-14">' + result + '</div>';
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "40px",
                    "render": (data, type, row) => {
                        if (!this.options.canRespond || !row.step.get('isActive') || (!this.options.isAdmin && (!row.get('isMe') || row.get('statusId') == null))) {
                            return '';
                        }

                        return `<div class="btn-group">
                                    <button type="button"
                                            class="btn fs-16 btn-transparent-dark text-dark dropdown-toggle" data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false">
                                        <i class="fas fa-ellipsis-vertical"></i>
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item btn-update-response"
                                           href="javascript:void(0)">Update Response</a>
                                    </div>
                                </div>`;
                    }
                }];
        }

        this.stepsDatatable = new PJQ.views.dataTables.DataTable({
            el: this.$('.dt-steps'),
            data: data,
            isHideSearch: true,
            groupBy: this.options.isEdit ? null : 'step.attributes.number',
            language: {
                emptyTable: 'No Steps have been created yet',
                zeroRecords: 'No Steps have been created yet'
            },
            isStriped: false,
            paging: false,
            order: [[0, "asc"]],
            columns: columns,
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: (row) => {
                            this.deleteStep(row.data());
                        },
                        isShown: () => {
                            return this.options.isEdit;
                        },
                    }
                ]
            },
            disableGroupToggle: true,
            getGroupHeader: (group) => {
                let step = this.model.steps.get(group),
                    bicBtn = '';
                if (!step.get('isActive') && this.options.canChangeBallInCourt) {
                    bicBtn = '<button data-step-cid="' + step.cid + '" class="btn fs-14 btn-sm btn-outline-dark btn-set-bic ml-auto">Set Ball In Court</button>';
                }

                let activeBadge = '';
                if (step.get('isActive') && this.options.canRespond) {
                    activeBadge = '<span class="badge badge-success fs-12 ml-2">Active</span>';
                }

                return '<div class="d-flex align-items-center wd-100 p-2" style="height:50px"><div class="fs-16 font-weight-light"><strong>#' + step.get('number') + '</strong></div>' + activeBadge + bicBtn + '</div>';
            },
            onRowDoubleClick: () => {

            },
        });
    }
});

PJQ.views.submittals.WorkflowResponseModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'modal-workflow-response'),
        maxWidth: 650,
    },
    events: {
        'keyup .input-comment': 'commentChanged',
        'click .btn-back': 'previousStep',
        'click .btn-next': 'nextStep',
        'click .btn-save': 'save',
        'click .btn-cancel': 'cancel'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.step = 1;

        this.options.statuses = await this.options.project.fetchSubmittalStatuses();

        if (this.model == null) {
            this.model = new PJQ.models.submittals.WorkflowResponse({
                submittalId: this.options.submittal.id
            });
        }
        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            model: this.model,
            approver: this.options.approver,
            statuses: this.options.statuses,
            submittal: this.options.submittal,
            step: this.step
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.StepIndicator(this.$('.steps-outer'), {
            steps: [{
                name: '',
                // name: 'Upload Attachments'
            }, {
                name: '',
                // name: 'Respond'
            }, {
                name: '',
                // name: 'Review & Submit'
            }],
            activeStep: this.step - 1
        });

        switch (this.step) {
            case 1:
                this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                    el: this.$('.step-uploader'),
                    collection: this.model.attachments,
                    includeProjectAttachments: true,
                    versionByName: true,
                    getParentAttachment: (fileModel) => {
                        return _.find(this.options.submittal.attachments.models, (file) => {
                            return file.get('name') === fileModel.get('name') && !file.get('delete')
                                && (file.get('parentAttachmentId') == null || file.get('parentAttachmentId') === file.id);
                        });
                    },
                    onSuccess: _.bind(function () {

                    }, this),
                    onDelete: _.bind(function (attachment, callback) {

                    }, this)
                });
                break;
            case 2:
                this.statusPicker = new PJQ.inputs.Selectpicker({
                    el: this.$('.select-status'),
                    noneSelectedText: 'Select Status',
                    isIntChoices: true,
                    defaultValue: this.model.get('statusId'),
                    choices: _.map(_.filter(this.options.statuses.models, (status) => {
                        return status.get('type') === PJQ.constants.submittals.statusTypes.APPROVED || status.get('type') === PJQ.constants.submittals.statusTypes.REJECTED;
                    }), (status) => {
                        return {
                            id: status.id,
                            name: status.get('name')
                        };
                    }),
                    onChange: _.bind(function (value) {
                        this.model.set('statusId', value);
                    }, this)
                });
                break;
            case 3:
                break;
        }
    },
    commentChanged: function (e) {
        this.model.set({
            responseText: this.$('.input-comment').val()
        });
    },
    previousStep: function () {
        this.step--;
        this.render();
    },
    nextStep: function () {
        switch (this.step) {
            case 1:
                break;
            case 2:
                if (this.model.get('statusId') == null) {
                    this.statusPicker.showError();
                    return;
                }
                break;
            case 3:
                break;
        }

        this.step++;
        this.render();
    },
    save: function () {
        let loader = new PJQ.Loader(this.$('.modal-content'));
        this.options.submittal.respond(this.model, this.options.approver?.get('personId'), (success) => {
            if (!success) {
                loader.remove();
                return;
            }

            this.options.onSave(this.model);
            this.removeModal();

            PJQ.notifications.notify.successNotify({
                message: 'Response submitted successfully'
            });
        });
    },
    cancel: function () {
        new PJQ.views.modals.YesNo({
            header: "Cancel Response?",
            body: "Are you sure you want to cancel this response? All changes will be lost.",
            onYes: () => {
                this.removeModal();
            }
        });
    }
});

PJQ.views.submittals.EditWorkflowTemplateModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'modal-edit-workflow-template'),
        maxWidth: 650,
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-cancel': 'cancel',
        'click .btn-delete': 'deleteTemplate'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        if (this.model != null) {
            await this.model.fetch();
        }

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            model: this.model,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        if (this.model.isNew()) {
            this.$('.input-template-name').focus();
        }

        this.binder = new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input',
                'textarea'
            ]
        });

        this.workflowView = new PJQ.views.submittals.WorkflowView({
            el: this.$('.workflow-outer'),
            model: this.model.workflow,
            project: this.options.project,
            isEdit: true,
            canEdit: true,
            onChange: () => {
                this.model.isDirty = true;
            }
        });
    },
    validate: function () {
        let $name = this.$('.input-template-name');
        PJQ.helpers.inputHelpers.setInputError($name, true);
        if (this.model.get('name') == null || this.model.get('name').trim() === '') {
            PJQ.helpers.inputHelpers.setInputError($name, false);
            return false;
        }

        return true;
    },
    save: function () {
        if (!this.validate()) {
            return;
        }

        this.model.save(null, {
            success: () => {
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
                this.removeModal();

                PJQ.notifications.notify.successNotify({
                    message: 'Template saved successfully'
                });
            },
            error: () => {
                PJQ.notifications.notify.errorNotify({
                    message: 'An error occurred while saving the template'
                });
            }
        });
    },
    cancel: function () {
        if (this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    },
    deleteTemplate: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Delete Submittal Workflow Template?",
            body: "Are you sure you want to delete this workflow template? This cannot be undone.",
            onDelete: () => {
                this.model.destroy({
                    success: () => {
                        if (typeof this.options.onSave === 'function') {
                            this.options.onDelete();
                        }
                        this.removeModal();
                    },
                    error: () => {
                        PJQ.notifications.notify.errorNotify({
                            message: 'Failed to delete workflow template'
                        });
                    }
                });
            }
        });
    }
});